/* «مساعدة سندس» — the chat sheet (plan: .cursor/plans/2026-10-22/sondos-ai-shopping-assistant.plan.md).
 *
 * Loaded only after the launcher has appeared (snippets/sondos-assistant.liquid),
 * never at page load. Talks to the Worker in .cursor/skills/store/sondos-assistant/
 * over one POST that streams Server-Sent Events: meta · status · delta · cards ·
 * policy · handoff · refusal · done · error.
 *
 * What the customer sees is built here from the events, with textContent only —
 * nothing the server sends is ever parsed as HTML. Products are added to the
 * cart on this origin (/cart/add.js) with the hidden line property
 * «_Added by: Chat», the same pattern ARB uses with «AI», so orders that came
 * through the assistant show up in the BI report.
 *
 * Memory: the device keeps two random ids (device + open conversation), in
 * localStorage AND sessionStorage — Instagram's in-app browser wipes
 * localStorage at random. Everything else lives on the server, 30 days.
 */
(function () {
  'use strict';
  if (window.SondosAssistant && window.SondosAssistant.ready) return;

  var root = document.getElementById('sondos-assistant');
  if (!root) return;

  var cfg = {
    endpoint: (root.getAttribute('data-endpoint') || '').replace(/\/+$/, ''),
    pageType: root.getAttribute('data-page-type') || '',
    product: root.getAttribute('data-product') || '',
    productTitle: root.getAttribute('data-product-title') || '',
    avatar: root.getAttribute('data-avatar') || '',
    wa: 'https://api.whatsapp.com/send?phone=970597298636'
  };
  cfg.demo = !cfg.endpoint;
  /* Off the published theme (R3, any preview) a chat is the owner testing: the Worker keeps it but does not count
     it as a customer on the dashboard. Unknown counts as a customer, so a real one is never hidden. */
  /* The chat page has no Shopify scripts (they made it slow, see templates/index.sondos-assistant.liquid), so the
     store page she came from tells: snippets/sondos-assistant.liquid writes sessionStorage sas_test from
     Shopify.theme.role. A preview link counts as a test too. */
  var testMark = null;
  try { testMark = sessionStorage.getItem('sas_test'); } catch (e) {}
  cfg.test = testMark === '1' || /[?&]preview_theme_id=/.test(location.search) || !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  /* Its own page (templates/index.sondos-assistant.liquid, owner 2026-10-23:
     «خليها تفتح شاشة وخلص»): where she came from arrives in the query. */
  cfg.page = root.getAttribute('data-mode') === 'page';
  var query = {};
  if (cfg.page) {
    try { new URLSearchParams(location.search).forEach(function (v, k) { query[k] = v; }); } catch (e) {}
    cfg.pageType = query.from === 'product' || query.from === 'cart' || query.from === 'collection' ? query.from : '';
    // the collection page she came from (2026-10-27): the Worker reads that page's products as facts
    cfg.collection = cfg.pageType === 'collection' ? (query.c || '').slice(0, 200) : '';
    cfg.collectionTitle = cfg.pageType === 'collection' ? (query.t || '').slice(0, 120) : '';
    // which way in opened the chat (2026-10-27): the Worker keeps it on the chat it starts, for the numbers
    cfg.src = /^[a-z][a-z-]{1,23}$/.test(query.src || '') ? query.src : '';
    cfg.product = cfg.pageType === 'product' ? (query.p || '') : '';
    cfg.productTitle = cfg.pageType === 'product' ? (query.t || '').slice(0, 120) : '';
    /* A fresh start (owner 2026-10-27: «حاسس انه مش حلو يفتح هيك»): the rows of the collection, the empty
       cart, a search with no result and «حكاية سندس» open the welcome and its ways in, not the last chat — that
       one stays saved; the cart and the product page keep their question in the link. */
    cfg.fresh = query.new === '1';
    // a question that came in the link is asked once: off the address bar, so
    // a reload or Back from a product does not ask it again (nor start over again)
    if (query.q || query.new) {
      try {
        var u = new URL(location.href);
        u.searchParams.delete('q');
        u.searchParams.delete('new');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
  }

  /* ───────────────────────── storage (never trusted, never required) ───────────────────────── */
  var K_DEVICE = 'sas_device', K_CONV = 'sas_conv', K_DRAFT = 'sas_draft';
  var touchKeys = window.matchMedia('(pointer: coarse)').matches;   // a phone or tablet keyboard (see the compose box)
  function store(key, value) {
    try { if (value == null) localStorage.removeItem(key); else localStorage.setItem(key, value); } catch (e) {}
    try { if (value == null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, value); } catch (e) {}
  }
  function read(key) {
    var v = null;
    try { v = localStorage.getItem(key); } catch (e) {}
    if (!v) { try { v = sessionStorage.getItem(key); } catch (e) {} }
    return v;
  }
  function randomId() {
    var b = new Uint8Array(12);
    (window.crypto || window.msCrypto).getRandomValues(b);
    return Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
  }
  var device = read(K_DEVICE);
  if (!/^[a-f0-9]{24}$/.test(device || '')) { device = randomId(); }
  store(K_DEVICE, device);
  var conversation = read(K_CONV);

  /* ───────────────────────── tiny DOM helpers ───────────────────────── */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function svg(path, size) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('width', size || 20);
    s.setAttribute('height', size || 20);
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '1.7');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.innerHTML = path; // static, authored here
    return s;
  }
  var ICON = {
    close: '<path d="M7 7l10 10M17 7L7 17"/>',
    more: '<circle cx="5" cy="12" r="1.2"/><circle cx="12" cy="12" r="1.2"/><circle cx="19" cy="12" r="1.2"/>',
    send: '<path d="M12 19V5M6 11l6-6 6 6"/>',
    up: '<path d="M7 11v8H4v-8h3zM7 11l4-7c1.3 0 2 .8 2 2v3h5.2c1 0 1.8.9 1.6 1.9l-1.2 6.4c-.2.9-.9 1.7-1.9 1.7H7"/>',
    down: '<path d="M17 13V5h3v8h-3zM17 13l-4 7c-1.3 0-2-.8-2-2v-3H5.8c-1 0-1.8-.9-1.6-1.9l1.2-6.4C5.6 5.8 6.3 5 7.3 5H17"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    sun: '<circle cx="12" cy="12" r="3.6"/><path d="M12 3v1.8M12 19.2V21M3 12h1.8M19.2 12H21M5.6 5.6l1.3 1.3M17.1 17.1l1.3 1.3M5.6 18.4l1.3-1.3M17.1 6.9l1.3-1.3"/>',
    moon: '<path d="M19.5 14.2A7.5 7.5 0 0 1 9.8 4.5 7.5 7.5 0 1 0 19.5 14.2z"/>',
    wa: '<path d="M4.5 19.5l1.1-3.6A8 8 0 1 1 8.6 18.9z"/><path d="M9.2 9.3c.3 2.2 2.2 4.4 5.2 5.4l1.1-1.2-1.6-1-1 .8c-1-.4-2.1-1.4-2.6-2.6l.8-1-1-1.6z"/>',
    jump: '<path d="M12 5v14M6 13l6 6 6-6"/>',
    spark: '<path d="M12 4.5l1.4 4.1 4.1 1.4-4.1 1.4L12 15.5l-1.4-4.1L6.5 10l4.1-1.4z"/><path d="M18.5 15.5l.6 1.6 1.6.6-1.6.6-.6 1.6-.6-1.6-1.6-.6 1.6-.6z"/>',
    clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>'
  };

  /* Prices exactly as the store writes them: «NIS 80», decimals only when real (sondos-money.liquid). */
  function money(n) {
    var v = Math.round(Number(n) * 100) / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2);
    return 'NIS ' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function bdiMoney(n, cls) {
    var b = el('bdi', cls, money(n));
    b.setAttribute('dir', 'ltr');
    return b;
  }

  /* ───────────────────────── the sheet ───────────────────────── */
  var ui = {};
  // gen: which chat the page is on now — an answer or a /session read started for an earlier one is dropped (QA recheck SA-QA-05)
  // pdp: which of the product page's two questions this chat can offer, from the Worker (/session?product=, done) — null = none
  var state = { open: false, busy: false, remaining: 15, turn: 0, built: false, resumed: false, pushed: false, gen: 0, abort: null, pdp: null };
  var lastFocus = null;

  function build() {
    if (state.built) return;
    state.built = true;
    var panel = el('div', 'sas-panel');
    panel.id = 'sas-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'sas-title');
    panel.setAttribute('dir', 'rtl');
    panel.hidden = true;

    var scrim = el('div', 'sas-scrim');
    scrim.addEventListener('click', close);

    var sheet = el('section', 'sas-sheet');

    var head = el('header', 'sas-head');
    /* Sondos's own mark, as at the top of the menu: the sheet reads as hers.
       The line under the name still says it is an AI (plan §5.2). */
    var mark = el('img', 'sas-head__mark');
    mark.src = cfg.avatar;
    mark.alt = '';
    mark.width = 36;
    mark.height = 36;
    mark.decoding = 'async';
    var titles = el('div', 'sas-head__text');
    var h = el('h2', 'sas-head__title', 'مساعدة سندس');
    h.id = 'sas-title';
    titles.appendChild(h);
    titles.appendChild(el('p', 'sas-head__sub', 'مساعدة ذكاء اصطناعي للعناية بالبشرة'));
    var moreBtn = el('button', 'sas-icon-btn');
    moreBtn.type = 'button';
    moreBtn.setAttribute('aria-label', 'خيارات');
    moreBtn.setAttribute('aria-expanded', 'false');
    moreBtn.appendChild(svg(ICON.more));
    var closeBtn = el('button', 'sas-icon-btn sas-close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'إغلاق');
    closeBtn.appendChild(svg(ICON.close, 26));   // a bigger ✕ (owner, 2026-10-24: «كبر اشوي زر الاغلاق»)
    closeBtn.addEventListener('click', close);
    if (cfg.avatar) head.appendChild(mark);
    head.appendChild(titles);
    head.appendChild(moreBtn);
    head.appendChild(closeBtn);

    var menu = el('div', 'sas-menu');
    menu.hidden = true;
    menu.setAttribute('role', 'menu');
    [['محادثة جديدة', newConversation], ['عن المساعدة', showAbout], ['امسحي ذاكرة المحادثات', forget]].forEach(function (it) {
      var b = el('button', 'sas-menu__item', it[0]);
      b.type = 'button';
      b.setAttribute('role', 'menuitem');
      b.addEventListener('click', function () { toggleMenu(false); it[1](); });
      menu.appendChild(b);
    });
    var waItem = el('a', 'sas-menu__item sas-menu__item--wa', 'احكي مع خبيرة سندس على واتساب');
    waItem.href = cfg.wa;
    waItem.target = '_blank';
    waItem.rel = 'noopener';
    waItem.setAttribute('role', 'menuitem');
    menu.appendChild(waItem);
    moreBtn.addEventListener('click', function () { toggleMenu(menu.hidden); });

    var log = el('div', 'sas-log');
    log.setAttribute('role', 'log');
    log.setAttribute('aria-live', 'polite');
    log.setAttribute('aria-relevant', 'additions');

    var chips = el('div', 'sas-chips');

    var form = el('form', 'sas-compose');
    form.setAttribute('novalidate', '');
    var input = el('textarea', 'sas-compose__input');
    input.rows = 3;
    input.maxLength = 600;   // the Worker's LIMITS.messageChars (owner, 2026-10-24: «ارفع الحد ل ٦٠٠»)
    input.setAttribute('aria-label', 'رسالتك');
    input.placeholder = PLACEHOLDER_START;
    /* On a phone the return key writes a new line and the pink button sends, as in WhatsApp: there is no
       Shift on a phone keyboard, so a return key that sent left her no way to start a line (owner's iPhone,
       2026-10-23). With a real keyboard Enter sends and Shift+Enter is a new line. */
    input.setAttribute('enterkeyhint', touchKeys ? 'enter' : 'send');
    var send = el('button', 'sas-compose__send');
    send.type = 'submit';
    send.setAttribute('aria-label', 'إرسال');
    send.appendChild(svg(ICON.send, 20));
    // how many characters are left, only once she is close to the limit (a cut paste is otherwise silent)
    var count = el('span', 'sas-compose__count');
    count.setAttribute('aria-live', 'polite');
    count.hidden = true;
    form.appendChild(input);
    form.appendChild(send);
    form.appendChild(count);
    input.addEventListener('input', function () {
      fitInput();
      send.disabled = !input.value.trim() || state.busy;
      try { sessionStorage.setItem(K_DRAFT, input.value); } catch (e) {}
    });
    input.addEventListener('keydown', function (e) {
      // 229: Safari ends a composition (Chinese, Japanese…) with an Enter that reports no composing
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && e.keyCode !== 229 && !touchKeys) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : submit(e); }
    });
    form.addEventListener('submit', submit);
    // the whole rounded box is the field: a tap on its edge writes too
    form.addEventListener('click', function (e) { if (e.target === form) input.focus(); });
    // the send tap does not take the focus away first (it would close the keyboard before the tap lands)
    send.addEventListener('mousedown', function (e) { if (document.activeElement === input) e.preventDefault(); });

    // no foot line under the box (owner, 2026-10-23: «هذه احذفها ما بدي اياها»): the AI notice stays in the head
    // («مساعدة ذكاء اصطناعي للعناية بالبشرة») and «عن المساعدة» says it can be wrong and is not medical advice

    var about = el('div', 'sas-about');
    about.hidden = true;
    about.setAttribute('role', 'dialog');
    about.setAttribute('aria-label', 'عن المساعدة');

    sheet.appendChild(head);
    sheet.appendChild(menu);
    var jumpWrap = el('div', 'sas-jumpwrap');
    var jump = el('button', 'sas-jump');
    jump.type = 'button';
    jump.setAttribute('aria-label', 'لآخر المحادثة');
    jump.tabIndex = -1;
    jump.appendChild(svg(ICON.jump, 18));
    jump.addEventListener('click', function () { state.manual = false; state.stick = true; scrollToEnd('bottom'); });
    jumpWrap.appendChild(jump);
    sheet.appendChild(log);
    sheet.appendChild(jumpWrap);
    sheet.appendChild(form);
    sheet.appendChild(about);
    if (cfg.page) panel.classList.add('sas-panel--page');
    panel.appendChild(scrim);
    panel.appendChild(sheet);
    document.body.appendChild(panel);

    panel.addEventListener('keydown', trapFocus);
    /* Store pages are sent no-store, so there is no back/forward cache: a link
       followed from the open sheet would leave the sheet's history entry behind
       as a dead Back. Leave with location.replace, which takes that entry with
       it — the same move as leave() in sondos-search.js. */
    panel.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (!state.pushed) return;
      e.preventDefault();
      unlockPage();
      location.replace(a.href);
    });
    ui = { panel: panel, sheet: sheet, log: log, chips: chips, form: form, input: input, send: send, count: count, menu: menu, moreBtn: moreBtn, about: about, jump: jump };
    /* Her own scrolling wins: following stops only when she really scrolls UP (a finger that wobbles on a
       tap no longer stops it), and comes back by itself when she returns to the end. */
    var touching = false, lastY = 0;
    log.addEventListener('touchstart', function () { touching = state.touching = true; }, { passive: true });
    log.addEventListener('touchend', function () { touching = state.touching = false; }, { passive: true });
    log.addEventListener('touchcancel', function () { touching = state.touching = false; }, { passive: true });
    log.addEventListener('wheel', function (e) { if (e.deltaY < 0) { state.manual = true; state.stick = false; } }, { passive: true });
    var ticking = false;
    log.addEventListener('scroll', function () {
      var y = log.scrollTop;
      if (touching && y < lastY - 2) { state.manual = true; state.stick = false; }
      // back at the end by her own hand: from now on the end is what she follows, as the answer grows (QA-15)
      else if (state.manual && log.scrollHeight - log.clientHeight - y < 24) { state.manual = false; state.stick = true; }
      lastY = y;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sheet.classList.toggle('is-scrolled', log.scrollTop > 4); updateJump(); });
    }, { passive: true });
    /* Keyboard up or down (the view is resized to what is above it): the line that was at the bottom of the
       view stays there, as in any messenger, then following carries on if she is following. */
    var lastH = 0;
    if (window.ResizeObserver) new ResizeObserver(function () {
      var h = log.clientHeight;
      // only a real keyboard change (well over 100px) moves what she sees; small drifts never do
      if (lastH && Math.abs(h - lastH) > 100) log.scrollTop += lastH - h;
      lastH = h;
      if (state.open) scrollToEnd('instant');
    }).observe(log);
    // what she was writing before she opened a product (or the page reloaded) is still there when she is back
    var draft = '';
    try { draft = sessionStorage.getItem(K_DRAFT) || ''; } catch (e) {}
    input.value = draft.slice(0, input.maxLength);
    fitInput();
    send.disabled = !input.value.trim();
  }

  /* The box follows what she writes: its height (three lines up to about six, then it scrolls inside), the
     direction of the text (a product name in Latin letters reads from the left, as in her messages), and
     how many characters are left once she is near the limit. The height is the content's own: scrollHeight
     counts the padding, and setting it back as the height added 8px each time, so an emptied box stayed
     taller than it started. */
  var padY = -1;
  function fitInput() {
    var i = ui.input;
    if (padY < 0) { var cs = getComputedStyle(i); padY = cs.boxSizing === 'border-box' ? 0 : (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0); }
    i.style.height = 'auto';
    i.style.height = Math.min(i.scrollHeight - padY, 150) + 'px';
    var first = /[A-Za-z؀-ۿ]/.exec(i.value);
    i.dir = first && /[A-Za-z]/.test(first[0]) ? 'ltr' : 'rtl';
    var left = i.maxLength - i.value.length;
    ui.count.hidden = left > 40;
    ui.count.textContent = String(Math.max(left, 0));
    ui.count.classList.toggle('is-out', left <= 0);
  }

  function toggleMenu(show) {
    // opens just under ⋯, whatever the head's height at this size
    if (show) ui.menu.style.top = (ui.moreBtn.offsetTop + ui.moreBtn.offsetHeight + 4) + 'px';
    ui.menu.hidden = !show;
    ui.moreBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show) { var f = ui.menu.querySelector('button'); if (f) f.focus(); }
  }

  function trapFocus(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      if (!ui.about.hidden) { closeAbout(); return; }
      if (!ui.menu.hidden) { toggleMenu(false); ui.moreBtn.focus(); return; }
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    // «عن المساعدة» open: Tab stays inside it — the chat behind it is out of sight (QA-14)
    var scope = ui.about.hidden ? ui.sheet : ui.about;
    var f = Array.prototype.filter.call(scope.querySelectorAll('button:not([disabled]), a[href], textarea, [tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (scope === ui.about && f.indexOf(document.activeElement) < 0) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ───────────────────────── open / close ───────────────────────── */
  /* Phone keyboard: iOS keeps a fixed full-screen sheet at the layout viewport
     and slides the keyboard over its bottom, so the compose bar would sit
     under it. While the sheet is open on a phone, it is sized to the visual
     viewport instead (the part of the screen above the keyboard). */
  var vv = window.visualViewport;
  /* Only while the keyboard is up. Safari fires visualViewport resize/scroll all the time — its toolbars,
     the rubber band — with values that drift by a few pixels; following each one moved the whole sheet up
     and down with no keyboard at all (owner's recording, 2026-10-23: «عادي الشاشة ترقص هيك»). Keyboard down:
     no inline size, the CSS fills the screen. */
  function fitViewport() {
    var s = ui.sheet;
    if (!s) return;
    /* and only while she is typing in it: Safari on the iPhone kept a short visual viewport after the keyboard
       went down, so the chat stayed cut at the keyboard's top with the screen empty under it (owner's screenshot,
       2026-10-27, Safari) — no field in focus means no keyboard, whatever the viewport says */
    var a = document.activeElement;
    var typing = !!a && s.contains(a) && (a.tagName === 'TEXTAREA' || a.tagName === 'INPUT');
    var kb = !!vv && typing && state.open && !window.matchMedia('(min-width: 750px)').matches && vv.height < document.documentElement.clientHeight - 120;
    if (!kb) {
      if (s.style.cssText || s.classList.contains('is-kb')) { s.style.cssText = ''; s.classList.remove('is-kb'); }
      return;
    }
    var top = Math.round(vv.offsetTop), h = Math.round(vv.height);
    if (Math.abs((parseFloat(s.style.top) || 0) - top) < 2 && Math.abs((parseFloat(s.style.height) || 0) - h) < 2 && s.classList.contains('is-kb')) return;
    s.style.top = top + 'px';
    s.style.bottom = 'auto';
    s.style.height = h + 'px';
    // keyboard up: the head and the foot line step back so the conversation keeps room
    // (the box itself keeps its three lines — owner, 2026-10-23: «بما اكبس… بصغر height تبعو»)
    s.classList.add('is-kb');
    scrollToEnd('instant');
  }
  // the keyboard comes and goes with the field's focus, even when Safari sends no viewport event for it
  document.addEventListener('focusin', function () { setTimeout(fitViewport, 60); });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      fitViewport();
      // the chat page itself never scrolls: what the keyboard scrolled is put back
      if (cfg.page && !(ui.sheet && ui.sheet.classList.contains('is-kb')) && window.scrollY) window.scrollTo(0, 0);
    }, 60);
    setTimeout(fitViewport, 400);
  });


  var docEl = document.documentElement;
  function lockPage() {
    // another sheet's lock is not ours to take or to lift
    if (!state.open || state.locked || docEl.classList.contains('sds-scroll-locked')) return;
    var off = window.scrollY || 0;
    docEl.setAttribute('data-scroll-lock-offset', String(off));
    docEl.classList.add('sds-scroll-locked');
    document.body.style.top = '-' + off + 'px';
    state.locked = true;
  }
  function unlockPage() {
    if (!state.locked) return;
    state.locked = false;
    var off = Number(docEl.getAttribute('data-scroll-lock-offset')) || 0;
    docEl.classList.remove('sds-scroll-locked');
    docEl.removeAttribute('data-scroll-lock-offset');
    document.body.style.top = '';
    window.scrollTo(0, off);
  }

  function open(opts) {
    opts = opts || {};
    build();
    if (state.open) { if (opts.prompt) sendMessage(opts.prompt); return; }
    state.open = true;
    lastFocus = document.activeElement;
    ui.panel.hidden = false;
    if (cfg.page) {
      // nothing under it to lock, slide over or step back from
      ui.panel.classList.add('is-open');
      if (vv) { vv.addEventListener('resize', fitViewport); vv.addEventListener('scroll', fitViewport); fitViewport(); }
      state.resumed = true;
      /* Her chat, from wherever she opens it (owner 2026-10-28: «من وين ما افتح المساعدة من الموقع اذا كان في محادثة سابقة تظهر»):
         a way in that used to start a new one (`new=1`: a collection, the empty cart, a search with nothing, «حكاية سندس») opens
         her last chat too; with none, that page's own welcome. «محادثة جديدة» is in the menu. */
      resume().then(function () { if (opts.prompt) sendMessage(opts.prompt); });
      if (window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { ui.input.focus(); }, 60);
      return;
    }
    document.documentElement.classList.add('sas-open');
    requestAnimationFrame(function () { ui.panel.classList.add('is-open'); });
    /* Pin the page under the sheet with the store's own lock (html.sds-scroll-locked,
       as the cart sheet and search do). iOS ignores overflow: hidden while the
       keyboard is up, so the page crept on behind the sheet and showed through
       for a frame each time the sheet caught up (owner's recording, 2026-10-23:
       reviews, then the footer, flashing above the keyboard). One frame late, so
       the page relayout is not between her tap and the sheet. */
    requestAnimationFrame(function () { setTimeout(lockPage, 0); });
    /* Once slid up, the layer behind the phone sheet turns solid white: with the
       keyboard up iOS slides the visible area about and the sheet follows a
       frame late, which showed the page through the dim layer for a moment
       (owner's second recording, 2026-10-23). Not at open: the sheet slides up
       over the page. */
    clearTimeout(state.settleTimer);
    state.settleTimer = setTimeout(function () { if (state.open) ui.panel.classList.add('is-settled'); }, 360);
    if (vv) { vv.addEventListener('resize', fitViewport); vv.addEventListener('scroll', fitViewport); fitViewport(); }
    /* The phone's Back closes the sheet instead of leaving the page. */
    try { history.pushState({ sas: 1 }, ''); state.pushed = true; } catch (e) {}
    if (!state.resumed) {
      state.resumed = true;
      resume().then(function () { if (opts.prompt) sendMessage(opts.prompt); });
    } else if (opts.prompt) {
      sendMessage(opts.prompt);
    }
    setTimeout(function () { if (window.matchMedia('(min-width: 750px)').matches) ui.input.focus(); else ui.sheet.querySelector('.sas-icon-btn:last-of-type').focus({ preventScroll: true }); }, 60);
  }

  function close(fromHistory) {
    if (cfg.page) { leavePage(); return; }
    if (!state.open) return;
    state.open = false;
    if (vv) { vv.removeEventListener('resize', fitViewport); vv.removeEventListener('scroll', fitViewport); }
    unlockPage();
    clearTimeout(state.settleTimer);
    ui.panel.classList.remove('is-settled');
    if (document.activeElement === ui.input) ui.input.blur();
    toggleMenu(false);
    ui.about.hidden = true;
    ui.panel.classList.remove('is-open');
    document.documentElement.classList.remove('sas-open');
    setTimeout(function () { if (!state.open) ui.panel.hidden = true; }, 260);
    if (state.pushed && fromHistory !== true) { state.pushed = false; try { history.back(); } catch (e) {} }
    state.pushed = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  /* ✕ on the page: back to where she was (Back does the same by itself). */
  function leavePage() {
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).origin : ''; } catch (e) {}
    if (ref === location.origin && history.length > 1) history.back();
    else location.href = '/';
  }
  window.addEventListener('popstate', function () { if (state.open) { state.pushed = false; close(true); } });

  /* ───────────────────────── messages ───────────────────────── */
  /* Scrolling the way a good chat app does (owner, 2026-10-23: «ولما يطلع
     scroll»). When she sends, her message rises towards the top and the answer
     fills in under it: the view never runs past the start of what she asked,
     so a long answer or a routine is read from its first line and the cards
     under a short one come into sight (before, an answer could land entirely
     under the fold). If she scrolls herself, it stops following until she
     sends again; the ↓ button takes her to the end. */
  /* Where following stops: the start of her message — or, when her message is taller than about a third of
     the view (a long description with the keyboard up), its last lines, so the waiting dots and the first
     line of the answer are on screen. Before, a 13-line message on a phone with the keyboard up kept the
     answer's first line off screen the whole time (owner, 2026-10-23: «الرد الجديد بكون خارج الشاشة»). */
  function followTarget(log) {
    var end = log.scrollHeight - log.clientHeight;
    var a = state.anchor;
    if (!a || !a.isConnected) return end;
    var whole = a.offsetHeight + 12;   // her whole message when it takes under half the view, else its last lines
    var peek = whole <= log.clientHeight * 0.45 ? whole : Math.max(72, Math.round(log.clientHeight * 0.3));
    return Math.min(end, a.offsetTop + a.offsetHeight - peek);
  }
  /* One scroll a frame, after all that frame added (owner 2026-10-28: «بحسها بتعلق لحظات»): every message, card, status line and
     streamed word asked for it, and each ask measured the whole chat at once (a forced layout) — her saved chat drawn message by
     message spent 313 ms of a mid phone's opening in it alone. The asks of a frame are one; the strongest mode wins. */
  var SCROLL_RANK = { instant: 1, bottom: 2, force: 3 };
  var scrollAsked = false, scrollMode;
  function scrollToEnd(mode) {
    if (!ui.log) return;
    if (!scrollAsked || (SCROLL_RANK[mode] || 0) > (SCROLL_RANK[scrollMode] || 0)) scrollMode = mode;
    if (scrollAsked) return;
    scrollAsked = true;
    requestAnimationFrame(function () { scrollAsked = false; var m = scrollMode; scrollMode = undefined; scrollNow(m); });
  }
  function scrollNow(mode) {
    var log = ui.log;
    if (!log) return;
    var end = log.scrollHeight - log.clientHeight;
    if (mode === 'bottom') { log.scrollTo({ top: end, behavior: 'smooth' }); return; }
    if (!state.manual || mode === 'force') {
      // she took herself to the end (↓ or her own scroll) while the answer is still coming: follow the end,
      // not the start of her message — the answer's start stays the rule only until she chooses otherwise
      var target = state.stick ? end : followTarget(log);
      if (target > log.scrollTop + 1) log.scrollTo({ top: target, behavior: mode === 'instant' ? 'auto' : 'smooth' });
    }
    updateJump();
  }
  function updateJump() {
    var log = ui.log;
    if (!ui.jump) return;
    ui.jump.classList.toggle('is-on', log.scrollHeight - log.clientHeight - log.scrollTop > 140);
  }

  function addUser(text) {
    var m = el('div', 'sas-msg sas-msg--me');
    m.appendChild(el('p', 'sas-msg__text', text));
    ui.log.appendChild(m);
    state.anchor = m;
    state.manual = false;
    state.stick = false;
    scrollToEnd('force');
  }

  /* Her reply the way Sondos writes on WhatsApp: paragraphs with air between them, each line on its own,
     and the lead before «:» (a product, «الصبح») a little heavier — the owner's test read one dense
     block «متل محاضرة» (2026-10-23). textContent only. */
  function appendCopy(node, text) {
    var re = /[A-Za-z][A-Za-z0-9+%\/-]*(?:[ \t]+[A-Za-z0-9][A-Za-z0-9+%\/-]*)*/g;
    var at = 0, m;
    while ((m = re.exec(text))) {
      node.appendChild(document.createTextNode(text.slice(at, m.index)));
      var latin = el('bdi', null, m[0]);
      latin.dir = 'ltr';
      node.appendChild(latin);
      at = re.lastIndex;
    }
    node.appendChild(document.createTextNode(text.slice(at)));
  }

  function setText(node, str) {
    node.textContent = '';
    /* a lead glued after a full stop («…مجموعها 210 شيكل. الغسول: غسول…», persona tests 2026-10-31) starts its own line, so it
       is set in bold like the others (owner's layout: each product a paragraph of its own) */
    str = String(str || '').replace(/([.!؟])[ \t]+([^\s:：.،؛!؟\d][^\n:：.،؛!؟]{1,38})[:：][ \t]+/g, '$1\n$2: ');
    String(str || '').split(/\n\s*\n/).forEach(function (para) {
      var lines = para.split('\n').filter(function (l) { return l.trim(); });
      if (!lines.length) return;
      var p = el('p', 'sas-par');
      lines.forEach(function (line) {
        var s = el('span', 'sas-line');
        var m = line.match(/^([^:：.؟!]{2,40})[:：]\s+(.+)$/);
        if (m) {
          var heading = el('b');
          appendCopy(heading, m[1] + ':');
          s.appendChild(heading);
          var body = el('span', 'sas-line__body');
          appendCopy(body, ' ' + m[2]);
          s.appendChild(body);
        } else appendCopy(s, line);
        p.appendChild(s);
      });
      node.appendChild(p);
    });
  }

  function botMessage() {
    var m = el('div', 'sas-msg sas-msg--bot');
    var text = el('div', 'sas-msg__text');
    var extras = el('div', 'sas-msg__extras');
    m.appendChild(text);
    m.appendChild(extras);
    ui.log.appendChild(m);
    return { node: m, text: text, extras: extras };
  }

  function addBot(textStr) {
    var b = botMessage();
    setText(b.text, textStr);
    scrollToEnd();
    return b;
  }

  function status(b, text) {
    var s = b.node.querySelector('.sas-status');
    if (!text) { if (s) s.remove(); return; }
    if (!s) {
      s = el('div', 'sas-status');
      s.appendChild(el('span', 'sas-dots'));
      s.appendChild(el('span', 'sas-status__text'));
      b.node.insertBefore(s, b.text);
    }
    s.querySelector('.sas-status__text').textContent = text;
    scrollToEnd();
  }

  function rate(b, turn) {
    if (cfg.demo || !turn) return;
    var r = el('div', 'sas-rate');
    var label = el('span', 'sas-rate__label', 'الجواب فادك؟');
    r.appendChild(label);
    ['up', 'down'].forEach(function (v) {
      var btn = el('button', 'sas-rate__btn');
      btn.type = 'button';
      btn.setAttribute('aria-label', v === 'up' ? 'إفادني' : 'ما إفادني');
      btn.appendChild(svg(v === 'up' ? ICON.up : ICON.down, 16));
      btn.addEventListener('click', function () {
        r.classList.add('is-done');
        label.textContent = v === 'up' ? 'شكرًا 💛' : 'شكرًا، رح نحسّنها';
        r.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
        btn.classList.add('is-on');
        post('/feedback', { device: device, conversation: conversation, turn: turn, value: v });
      });
      r.appendChild(btn);
    });
    b.node.appendChild(r);
  }

  function setChips(list) {
    ui.chips.textContent = '';
    if (list && list.length) ui.log.appendChild(ui.chips);
    (list || []).forEach(function (c) {
      var b = el('button', 'sas-chip', c.label);
      b.type = 'button';
      b.addEventListener('click', function () { if (state.busy) return; c.run ? c.run() : sendMessage(c.send || c.label); });
      ui.chips.appendChild(b);
    });
    ui.chips.hidden = !ui.chips.childNodes.length;
    if (!ui.chips.hidden) scrollToEnd();
  }

  /* The opening — the owner's own words and shape (2026-10-23, «خد النصوص من
     هون»): the four ways in are full-width rows with their icons under the
     greeting (chips above the field were tried and turned down the same day:
     «ما حبيت التراجع»); the product page and the cart get questions about
     what she is looking at.
     That this is an AI stays in the head («مساعدة ذكاء اصطناعي للعناية بالبشرة»),
     visible at the first interaction (EU AI Act Art. 50; plan §5.2); «can be wrong,
     not medical advice» lives in «عن المساعدة» since the owner removed the foot line
     (2026-10-23: «هذه احذفها ما بدي اياها»). */
  var START_ICON = {
    skin: '<path d="M9.2 4.5c2.2 2.6 4 4.8 4 7a4 4 0 0 1-8 0c0-2.2 1.8-4.4 4-7z"/><path d="M15.8 9.5c1.5 1.8 2.7 3.3 2.7 4.8a2.7 2.7 0 0 1-5.4 0"/>',
    issue: '<path d="M12 19.5s-7-4.3-7-9.6A3.9 3.9 0 0 1 12 7.6a3.9 3.9 0 0 1 7 2.3c0 5.3-7 9.6-7 9.6z"/><path d="M7.5 12h2.2l1.3-2 1.8 4 1.3-2h2.4"/>',
    routine: '<path d="M5 8h14M5 12h14M6 16h12"/><path d="M8 4.5h8"/>',
    question: '<path d="M4 5.5h10.5v7.5H8L4 16z"/><path d="M14.5 9H20v8l-3-2h-5.5v-2"/>',
    go: '<path d="M15 6l-6 6 6 6"/>'
  };

  function starts() {
    if (!cfg.fresh && cfg.pageType === 'product' && cfg.product) {
      return [
        { icon: 'skin', label: 'شو فوائد هاد المنتج ولمين بناسب؟', send: 'شو فوائد هاد المنتج ولمين بناسب؟' },
        { icon: 'routine', label: 'شو بحط معه بالروتين؟', send: 'شو بحط معه بالروتين؟' },
        { icon: 'question', label: 'كيف بستعمله؟', send: 'كيف بستعمل هاد المنتج؟' },
        { icon: 'routine', label: 'بدي روتين عناية كامل', run: intake }
      ];
    }
    if (!cfg.fresh && cfg.pageType === 'cart') {
      return [
        { icon: 'routine', label: 'المنتجات اللي بسلتي بيمشوا مع بعض؟', send: 'المنتجات اللي بسلتي بيمشوا مع بعض؟ بأي ترتيب بستعملهم؟' },
        { icon: 'skin', label: 'شو ناقصني بالروتين؟', send: 'شو ناقصني بالروتين حسب اللي بسلتي؟' },
        { icon: 'question', label: 'كم التوصيل لمنطقتي؟', send: 'كم التوصيل لمنطقتي وكم بيوخذ وقت؟' }
      ];
    }
    return [
      { icon: 'issue', label: 'عندي مشكلة ببشرتي', run: function () { ui.input.placeholder = 'احكيلي شو بتلاحظي… مثلًا: آثار حبوب على الخدود'; ui.input.focus(); } },
      { icon: 'routine', label: 'بدي روتين عناية كامل', run: intake },
      { icon: 'question', label: 'عندي سؤال عن منتج', run: function () { ui.input.placeholder = 'اكتبي اسم المنتج وسؤالك…'; ui.input.focus(); } }
    ];
  }

  var WELCOME = 'محتارة شو تختاري لبشرتك؟ أنا هون أساعدك تلاقي المنتجات والروتين المناسب إلكِ 💗';
  var PLACEHOLDER_START = 'أو احكيلي شو بتحتاجي...';
  var PLACEHOLDER = 'اكتبي سؤالك…';

  /* The four ways in are only for the first step: once she picks one, or
     writes her own, they fold away so the chat gets the screen (owner,
     2026-10-23: «بنضل حاجزين… القسم من الشاشة مش مستخدمينه»). Her pick
     stays as her own bubble; «محادثة جديدة» brings them back. */
  var opening = null;
  function foldOpening() {
    var o = opening;
    opening = null;
    if (!o || !o.isConnected) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { o.remove(); return; }
    o.style.height = o.offsetHeight + 'px';
    void o.offsetHeight;
    o.classList.add('is-folding');
    o.style.height = '0px';
    setTimeout(function () {
      o.remove();
      // an answer that landed while it folded must still be read from its top
      var log = ui.log;
      if (state.manual || !state.anchor || !state.anchor.isConnected) return;
      var target = followTarget(log);
      if (log.scrollTop > target + 1) log.scrollTop = Math.max(0, target);
    }, 340);
  }

  /* From a collection page (the owner's words, 2026-10-27, then «خلي الحكي متناسق اكثر ومرتب»): her need is that page's,
     so the opening asks about her and nothing else — two questions, one per line, each led like «الصبح:» in her replies;
     no list of ways in; the Worker reads that page's products as facts (page.collection). */
  var COL_WELCOME = 'أهلين فيكي حبيبتي 🌸\nبساعدك تختاري الأنسب لبشرتك من هالمجموعة.\n\nنوع بشرتك: دهنية، جافة، مختلطة ولا حساسة؟\nمشكلتك: شو أكثر إشي حابة تعالجيه؟';

  /* From her cart (owner 2026-10-28: «زي ما بعمل بالواتساب لما زبونة تبعتلي شو رأيك بسلتي»): Sondos reviews what she chose,
     so the opening says so and asks her skin and her problem first, the collection's way; the Worker reads her cart itself. */
  // the owner's own words (2026-10-28)
  var CART_WELCOME = 'هلا حبيبتي 🌸\nخليني أتأكد إن المنتجات اللي بسلتك مناسبة لبشرتك وبتكمّل بعض.\nشو نوع بشرتك؟ وشو أكثر إشي مضايقك فيها؟';
  var cartReview = cfg.pageType === 'cart' && cfg.src !== 'cart-empty';

  function welcome() {
    if (cfg.pageType === 'collection' || cartReview) {
      var cw = addBot(cartReview ? CART_WELCOME : COL_WELCOME);
      cw.node.classList.add('sas-msg--welcome');
      ui.input.placeholder = cartReview ? 'مثلًا: بشرتي دهنية وعندي تصبغات…' : 'مثلًا: بشرتي دهنية وعندي رؤوس سودا…';
      setChips([]);
      scrollToEnd('force');
      return;
    }
    var b = addBot(cfg.pageType === 'product' && cfg.productTitle ? WELCOME + '\nأو اسأليني عن «' + cfg.productTitle + '».' : WELCOME);
    b.node.classList.add('sas-msg--welcome');
    opening = el('div', 'sas-opening');
    opening.appendChild(el('p', 'sas-ask', 'كيف بتحبي أساعدك اليوم؟'));
    var list = el('div', 'sas-starts');
    list.setAttribute('role', 'list');
    starts().forEach(function (st) {
      var row = el('button', 'sas-start');
      row.type = 'button';
      row.setAttribute('role', 'listitem');
      row.appendChild(svg(START_ICON[st.icon], 22));
      row.appendChild(el('span', 'sas-start__label', st.label));
      var go = svg(START_ICON.go, 18);
      go.setAttribute('class', 'sas-start__go');
      row.appendChild(go);
      row.addEventListener('click', function () {
        if (state.busy) return;
        list.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
        row.classList.add('is-chosen');
        foldOpening();
        st.run ? st.run() : sendMessage(st.send);
      });
      list.appendChild(row);
    });
    opening.appendChild(list);
    b.extras.appendChild(opening);
    ui.input.placeholder = PLACEHOLDER_START;
    setChips([]);
    scrollToEnd('force');
  }



  /* ───────────────────────── guided intake («ابني روتيني», plan §5.3) ───────────────────────── */
  /* Skin is asked by what she sees, not by a type label (sondos-daily-tips voice) — and sent as the type it means, with the
     choice as a fixed fact (owner 2026-10-26: «بتلمع بكل الوجه» was read as a pores concern in some turns, and the plan's
     cream followed the guess). [what she taps, what is said for her, the skin type] */
  var SKIN = [
    ['بتلمع بكل الوجه', 'بشرتي دهنية', 'oily'],
    ['بتلمع بالجبين والأنف بس', 'بشرتي مختلطة', 'combination'],
    ['بتشدّ وبتتقشّر', 'بشرتي جافة', 'dry'],
    ['بتلمع بس بتشدّ بعد الغسيل', 'بشرتي دهنية بس عطشانة وبتشد بعد الغسيل', 'dehydrated_oily'],
    ['مرتاحة، لا بتلمع ولا بتشد', 'بشرتي عادية', 'normal'],
    ['بتتهيّج بسرعة', 'بشرتي حساسة وبتتهيج بسرعة', 'sensitive']
  ];
  var CONCERN = [['حبوب', 'حبوب', 'acne'], ['آثار وبقع', 'آثار وبقع', 'spots'], ['مسام ورؤوس سوداء', 'مسام ورؤوس سوداء', 'pores'], ['جفاف', 'جفاف وعطش', 'dry'], ['خطوط دقيقة', 'خطوط دقيقة', 'wrinkles'], ['تهيّج', 'تهيج', 'redness'], ['بهتان', 'بهتان', 'glow'], ['حاجز متعب', 'حاجز البشرة متعب', 'barrier']];

  function ask(question, options, done, extra) {
    addBot(question);
    setChips(options.map(function (o) { return { label: o[0], run: function () { addUser(o[0]); done(o[1], o[2]); } }; }).concat(extra || []));
  }

  function intake() {
    var a = {};
    setChips([]);
    addUser('بدي روتين عناية كامل');
    ask('خلّينا نلاقي الروتين الأنسب لبشرتك 🌸 احكيلي، كيف طبيعة بشرتك؟', SKIN, function (v, skinType) {
      a.skin = v;
      a.skinType = skinType;
      ask('شو أكتر إشي بدك نشتغل عليه؟', CONCERN, function (v2, concernId) {
        a.concern = v2;
        a.concernId = concernId;
        ask('حامل، مرضعة، أو بتخططي للحمل؟', [['لا', 'مش حامل ولا مرضعة'], ['نعم', 'أنا حامل أو مرضعة'], ['بفضّل ما أجاوب', 'بفضل ما أجاوب عن الحمل']], function (v3) {
          a.preg = v3;
          ask('شو بتستعملي هلأ من مواد فعّالة؟', [['ولا إشي', 'ما بستعمل هلأ مواد فعالة'], ['ريتينول', 'بستعمل ريتينول'], ['أحماض AHA/BHA', 'بستعمل أحماض مقشرة'], ['فيتامين C', 'بستعمل فيتامين C'], ['علاج بوصفة', 'بستعمل علاج بوصفة طبيب']], function (v4) {
            a.actives = v4;
            ask('كم خطوة مريحة إلك بالروتين؟', [['3 أساسية', 'بسيط من 3 خطوات'], ['4–5', 'من 4 أو 5 خطوات'], ['6 وأكثر', 'من 6 خطوات أو أكتر']], function (v5) {
              a.size = v5;
              ask('في ميزانية تقريبية للروتين كامل؟', [['200', 'ميزانيتي حوالي 200 شيكل'], ['300', 'ميزانيتي حوالي 300 شيكل'], ['400', 'ميزانيتي حوالي 400 شيكل'], ['بدون حد', 'ما عندي حد للميزانية']], function (v6) {
                a.budget = v6;
                setChips([]);
                /* in her own words, not a form (owner 2026-10-25: the button's «بدي 5 خطوات» made Sondos fill five slots —
                   a second niacinamide as the fifth — where the same facts written as a customer writes got four) */
                sendMessage(a.skin + '، وأكتر إشي بدي أشتغل عليه ' + a.concern + '. ' + a.preg + '، و' + a.actives + '. بدي روتين كامل ' + a.size + '، و' + a.budget + '.', { silent: true, intake: { skin: a.skinType, concerns: [a.concernId] } });
              });
            });
          });
        });
      });
    });
  }

  function quickSkin() {
    setChips([]);
    addUser('ساعديني أختار منتجات لبشرتي');
    var a = {};
    ask('كيف بتكون بشرتك عادةً؟', SKIN, function (v, skinType) {
      a.skin = v;
      ask('وشو أكتر إشي بيضايقك فيها؟', CONCERN, function (v2, concernId) {
        setChips([]);
        sendMessage(a.skin + '، وبدي منتجات ل' + v2 + '.', { silent: true, intake: { skin: skinType, concerns: [concernId] } });
      });
    });
  }

  /* ───────────────────────── products ─────────────────────────
     Small upright cards in a row she swipes — about three across a phone,
     the next one peeking (owner, 2026-10-23: smaller products, a soft look,
     «لازم تتفوق… تعمل اشي عالمي», and no sideways rows). The picture leads;
     the add is a quiet «+» on its corner that turns into ✓. */
  var PLUS = '<path d="M12 6v12M6 12h12"/>';
  function productCard(p) {
    var card = el('article', 'sas-card');
    card.setAttribute('role', 'listitem');
    var media = el('div', 'sas-card__media');
    var link = el('a', 'sas-card__img');
    link.href = p.url;
    link.setAttribute('aria-label', p.title);
    if (p.image) {
      var img = el('img');
      img.src = p.image;
      img.alt = '';
      img.width = 160;
      img.height = 160;
      img.loading = 'lazy';
      img.decoding = 'async';
      fadeIn(img);
      link.appendChild(img);
    }
    media.appendChild(link);
    var have = haveOf(p);
    if (have && !p.another) {
      // already in her cart: said, not offered again
      media.appendChild(el('span', 'sas-card__have', haveLabel(p, have)));
    } else {
      var add = el('button', 'sas-card__add');
      add.type = 'button';
      add.setAttribute('aria-label', (p.another ? 'أضيفي حبة كمان من ' : 'أضيفي ') + p.title + ' للسلة');
      add.appendChild(svg(PLUS, 16));
      if (!p.available) { add.disabled = true; add.setAttribute('aria-label', p.title + ' — نفد'); }
      else add.addEventListener('click', function () { checkedAdd([p], [add]); });
      media.appendChild(add);
    }
    card.appendChild(media);
    var t = el('a', 'sas-card__title', p.title);
    t.href = p.url;
    card.appendChild(t);
    var price = el('p', 'sas-card__price');
    price.appendChild(bdiMoney(p.price, 'sas-card__now'));
    card.appendChild(price);
    if (have && p.another) card.appendChild(el('p', 'sas-card__more', 'عندك ' + have + ' بالسلة · هاي حبة كمان'));
    // the pace or «later» the Worker checked for an option in a list (a routine box shows them in its own rows)
    else if (p.later) card.appendChild(el('p', 'sas-card__more', 'لاحقًا، مش هلأ'));
    else if (p.pace) card.appendChild(el('p', 'sas-card__more', p.pace));
    return card;
  }

  function fadeIn(img) {
    var on = function () { img.classList.add('is-in'); };
    img.addEventListener('load', on);
    img.addEventListener('error', on);
    if (img.complete) on();
  }

  function addButton(p, opts) {
    var b = el('button', 'sas-add');
    b.type = 'button';
    b.setAttribute('aria-label', 'أضيفي ' + p.title + ' للسلة');
    b.appendChild(el('span', 'sas-add__label', (opts && opts.compact) ? 'أضيفي' : 'أضيفي للسلة'));
    if (!p.available) { b.disabled = true; b.firstChild.textContent = 'نفد'; return b; }
    b.addEventListener('click', function () { checkedAdd([p], [b]); });
    return b;
  }

  function renderCards(b, payload) {
    var items = payload.items || [];
    if (!items.length) return;
    if (payload.layout === 'routine') return renderRoutine(b, payload);
    var row = el('div', 'sas-cards' + (items.length === 1 ? ' sas-cards--one' : ''));
    row.setAttribute('role', 'list');
    items.forEach(function (p) { row.appendChild(productCard(p)); });
    b.extras.appendChild(row);
    scrollToEnd();
  }

  /* A routine reads as two short ordered lists — the morning and the night —
     with one primary action under them. */
  function renderRoutine(b, payload) {
    var byId = {};
    payload.items.forEach(function (p) { byId[p.id] = p; });
    var box = el('div', 'sas-routine');
    /* Four groups, as the Worker places them (v26): morning, night, weekly, and «later» — a product for a later
       stage, shown apart so she knows it is not for now; it stays out of the total and of «add all». Anything the
       Worker left outside the four (older replies) still shows under the weekly heading, as before. */
    var later = payload.later || [];
    // her body, hair or lips products: a section of their own, never a step of her face (Worker 2026-10-28)
    var apart = payload.apart || [];
    var placed = {};
    (payload.am || []).concat(payload.pm || [], payload.weekly || [], later, apart).forEach(function (id) { placed[id] = true; });
    var weekly = payload.weekly || [];
    var rest = payload.items.filter(function (p) { return !placed[p.id]; }).map(function (p) { return p.id; });
    var groups = [['am', 'الصبح', ICON.sun], ['pm', 'بالليل', ICON.moon]];
    // the weekly group is the plan's decision (v26.1): its heading follows it, whatever kind of product is in it. How many times
    // is each card's own (owner 2026-10-29: the heading said «مرة أو مرتين» over a card that said «3 مرات بالأسبوع»)
    if (weekly.length) groups.push(['weekly', 'بالأسبوع', ICON.spark]);
    // older replies, from before the Worker placed every card: a mask still reads as weekly, anything else as «with them»
    if (rest.length) groups.push(['rest', rest.every(function (id) { return byId[id] && byId[id].step === 'mask'; }) ? 'بالأسبوع' : 'كمان معهم', ICON.spark]);
    if (apart.length) groups.push(['apart', payload.apart_title || 'للجسم', ICON.spark]);
    if (later.length) groups.push(['later', 'لمرحلة لاحقة، مش هلأ', ICON.clock]);
    groups.forEach(function (g) {
      var ids = (g[0] === 'rest' ? rest : g[0] === 'later' ? later : g[0] === 'weekly' ? weekly : g[0] === 'apart' ? apart : (payload[g[0]] || [])).filter(function (id) { return byId[id]; });
      if (!ids.length) return;
      var sec = el('section', 'sas-routine__part');
      var hd = el('h3', 'sas-routine__head');
      hd.appendChild(svg(g[2], 16));
      hd.appendChild(el('span', null, g[1]));
      sec.appendChild(hd);
      var ol = el('ol', 'sas-routine__list');
      ids.forEach(function (id, i) {
        var p = byId[id];
        var li = el('li', 'sas-step');
        var n = el('span', 'sas-step__n', String(i + 1));
        var a = el('a', 'sas-step__media');
        a.href = p.url;
        a.setAttribute('aria-label', p.title);
        if (p.image) { var img = el('img'); img.src = p.image; img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy'; fadeIn(img); a.appendChild(img); }
        var txt = el('div', 'sas-step__text');
        txt.appendChild(el('span', 'sas-step__kind', (STEP_AR[p.step] || '') + (p.pace ? ' · ' + p.pace : '')));
        var tt = el('a', 'sas-step__title', p.title);
        tt.href = p.url;
        txt.appendChild(tt);
        if (p.why) txt.appendChild(el('span', 'sas-step__why', p.why));
        var pr = el('div', 'sas-step__end');
        pr.appendChild(bdiMoney(p.price, 'sas-step__price'));
        if (haveOf(p) && !p.another) pr.appendChild(el('span', 'sas-step__have', haveLabel(p, haveOf(p))));
        li.appendChild(n);
        li.appendChild(a);
        li.appendChild(txt);
        li.appendChild(pr);
        ol.appendChild(li);
      });
      sec.appendChild(ol);
      box.appendChild(sec);
    });
    var isLater = {};
    later.forEach(function (id) { isLater[id] = true; });
    var unique = payload.items.filter(function (p) { return p.available && !isLater[p.id]; });
    // what this plan adds to her cart: the steps she does not have yet (one more of a product only when she asked)
    var missing = unique.filter(function (p) { return p.another || !haveOf(p); });
    var foot = el('div', 'sas-routine__foot');
    var sum = el('p', 'sas-routine__total');
    /* The box as it was before (owner 2026-10-28: «بفضل نرجعه متل ما كان قبل… لما تكبس عليه المنتج اللي موجود بالسلة ما
       بضيفه واللي مش موجود بضيفه وخلص»): the whole routine and its total; the tap adds only what her cart lacks. */
    /* a box with no morning or night step is not a routine (owner 2026-10-29: a face mask, eye patches, foot socks and a mascara
       she asked for together read «أضيفي الروتين كله للسلة») */
    var daily = (payload.am || []).concat(payload.pm || []).some(function (id) { return byId[id]; });
    if (missing.length) {
      var routineTotal = unique.reduce(function (t, p) { return t + Number(p.price || 0); }, 0);
      sum.appendChild(el('span', null, unique.length + ' منتجات · '));
      sum.appendChild(bdiMoney(routineTotal));
      var all = el('button', 'sas-primary', daily ? 'أضيفي الروتين كله للسلة' : 'أضيفي الكل للسلة');
      all.type = 'button';
      all.addEventListener('click', function () { checkedAdd(missing, [all]); });
      foot.appendChild(sum);
      foot.appendChild(all);
      foot.appendChild(el('p', 'sas-routine__pick', 'أو افتحي أي منتج وأضيفيه لحاله.'));
    } else {
      foot.appendChild(el('p', 'sas-routine__total', daily ? 'كل منتجات الروتين بسلتك ✓' : 'كلهم بسلتك ✓'));
    }
    box.appendChild(foot);
    b.extras.appendChild(box);
    scrollToEnd();
  }
  var STEP_AR = { cleanser: 'غسول', toner: 'تونر', essence: 'إسنس', serum: 'سيروم', moisturizer: 'مرطّب', sunscreen: 'واقي شمس', 'eye cream': 'للعيون', mask: 'ماسك', exfoliator: 'مقشّر', 'spot treatment': 'للحبوب' };

  /* The policy is shown in its own words, as a quote of the page (plan §7.1). */
  function renderPolicy(b, payload) {
    var q = el('figure', 'sas-policy');
    var cap = el('figcaption', 'sas-policy__title', payload.title || 'سياسة المتجر');
    q.appendChild(cap);
    var dl = el('div', 'sas-policy__body');
    (payload.lines || []).forEach(function (l) {
      if (l.kind === 'heading') { dl.appendChild(el('p', 'sas-policy__h', l.text)); return; }
      var m = /^(.{2,40}?):\s(.+)$/.exec(l.text);
      if (m && /(₪|NIS|مجاني|\d)/.test(m[2])) {
        var r = el('p', 'sas-policy__rate');
        r.appendChild(el('span', null, m[1]));
        var v = el('bdi', 'sas-policy__val', m[2]);
        v.setAttribute('dir', 'ltr');
        r.appendChild(v);
        dl.appendChild(r);
      } else {
        dl.appendChild(el('p', 'sas-policy__p', l.text));
      }
    });
    q.appendChild(dl);
    if (payload.url) {
      var a = el('a', 'sas-policy__link', 'الصفحة كاملة');
      a.href = payload.url;
      q.appendChild(a);
    }
    b.extras.appendChild(q);
    scrollToEnd();
  }

  function renderHandoff(b, payload) {
    if (b.node.querySelector('.sas-wa')) return;
    var a = el('a', 'sas-wa');
    a.href = payload.url || cfg.wa;
    a.target = '_blank';
    a.rel = 'noopener';
    a.appendChild(svg(ICON.wa, 20));
    a.appendChild(el('span', null, 'احكي مع خبيرة سندس على واتساب'));
    b.extras.appendChild(a);
    scrollToEnd();
  }

  /* ───────────────────────── cart ───────────────────────── */
  function variantFor(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        if (avail.length === 1) return { id: avail[0].id };
        if (avail.length > 1) return { choose: true, url: '/products/' + encodeURIComponent(handle) };
        return { soldOut: true };
      });
  }

  /* Quantity of each variant in the cart now, or null when the cart cannot be read. */
  function cartCounts() {
    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return null;
        var q = {};
        (c.items || []).forEach(function (it) { q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
        return q;
      })
      .catch(function () { return null; });
  }

  /* ───────────────────────── her cart: one verified read per message ─────────────────────────
     Owner 2026-10-27 (plan .cursor/plans/2026-10-27/assistant-cart-architecture.plan.md): Shopify's cart is the truth.
     Every message carries the result of a /cart.js read started after she pressed send — `ok` with its lines by variant
     and quantity (an empty cart is ok with none), or `failed` with why — never an earlier read. Before, a failed read sent
     the last good one as if it were now, and the cart row's first message went with none (Live ca92b9fb). Each read is
     its own: there is no shared «latest cart» an older read could overwrite. A reply written about her cart is shown only
     after one more read finds the same cart. The Worker (cart.js) builds the same fingerprint. */
  var cartSeq = 0;
  var CART_CHANGED = 'سلتك تغيّرت وأنا بجهّز الجواب، فما بدي أجاوبك عن سلة قديمة 🌸';
  var CART_UNCHECKED = 'ما قدرت أتأكد من سلتك قبل ما أعرضلك الجواب 🙏 جرّبي كمان مرة.';
  var CART_THEN = 'هالجواب كان عن سلتك وقتها، وسلتك تغيّرت من بعدها.';
  var remarkSeq = 0;
  var haveSeq = 0, haveNow = null;   // her cart by product (handle → how many), from the newest read; null until one is read
  function qtyByHandle(snap) { var q = {}; (snap.lines || []).forEach(function (l) { q[l.handle] = (q[l.handle] || 0) + l.qty; }); return q; }
  /* how many she has of it: in her cart itself, or as a piece of a kit in her cart — the card names the kits that hold it
     (in_kits, a catalog fact), her cart read says whether one of them is there (2026-10-28) */
  function haveIn(q, p) { var n = q[p.id] || 0; if (!n) (p.in_kits || []).forEach(function (k) { if (q[k]) n = Math.max(n, 1); }); return n; }
  function haveOf(p) { return haveNow ? haveIn(haveNow, p) : (p.in_cart || 0); }
  function inKitOnly(p) { return !!(haveNow && !haveNow[p.id] && haveIn(haveNow, p)); }
  function haveLabel(p, n) { return 'بسلتك' + (inKitOnly(p) ? ' (ضمن مجموعة)' : n > 1 ? ' ×' + n : ''); }
  var unseenTurns = [];   // replies held back because her cart changed while they were written: the Worker is told with her next message
  // a one-way mark of Shopify's cart token (cyrb53): a new token is a new cart, after an order; the token itself stays here
  function markOf(str) {
    var h1 = 0xdeadbeef, h2 = 0x41c6ce57;
    for (var i = 0; i < str.length; i++) { var c = str.charCodeAt(i); h1 = Math.imul(h1 ^ c, 2654435761); h2 = Math.imul(h2 ^ c, 1597334677); }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
  }
  // the cart itself in a fixed order — «variant:qty» by variant id, two lines of one variant counted together
  function cartPrint(snap) {
    var by = {};
    (snap.lines || []).forEach(function (l) { by[l.variant] = (by[l.variant] || 0) + l.qty; });
    return Object.keys(by).map(Number).sort(function (x, y) { return x - y; }).map(function (v) { return v + ':' + by[v]; }).join(',');
  }
  /* After a read: a reply on the page written about another cart than hers now says so — and stops saying it when she is
     back to that cart. Only the newest read decides (an older one finishing late changes nothing). */
  function remarkCart(now) {
    if (!ui.log || now.seq < remarkSeq) return;
    remarkSeq = now.seq;
    var print = cartPrint(now);
    ui.log.querySelectorAll('[data-cart-fp]').forEach(function (n) {
      var note = n.querySelector('.sas-msg__cart');
      if (n.getAttribute('data-cart-fp') !== print) {
        if (!note) { note = el('div', 'sas-msg__cart'); n.insertBefore(note, n.querySelector('.sas-msg__extras')); }
        note.textContent = CART_THEN;
      } else if (note) note.remove();
    });
  }
  // she comes back to the chat (another tab, Back from the cart page) or added from here: replies about her cart are re-checked
  function recheckShown() { if (ui.log && ui.log.querySelector('[data-cart-fp]')) readCartNow(); }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') recheckShown(); });
  addEventListener('pageshow', function (e) { if (e.persisted) recheckShown(); });
  /* An empty cart has no cart of its own yet: Shopify gives each read of it a new token, so the check after a reply took every
     empty cart for a changed one and hid the reply (Live b1c12151, 2026-10-28: «؟ … ما فهمت … لا»). Two empty reads are the same. */
  function sameCart(x, y) { return !!(x && y && x.status === 'ok' && y.status === 'ok' && cartPrint(x) === cartPrint(y) && (x.cart === y.cart || !cartPrint(x))); }
  function readCartNow() {
    if (cfg.demo) return Promise.resolve({ status: 'none' });
    var seq = ++cartSeq, started = Date.now();
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    // one read; a network error, a 5xx or a 429 is tried once more at once. The 8 s bound only decides that it failed —
    // it never falls back to anything read before
    function once() {
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : 0;
      return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
        .then(function (r) {
          if (!r.ok) { var e = new Error('http'); e.reason = 'http_' + r.status; e.again = r.status >= 500 || r.status === 429; throw e; }
          return r.json().then(null, function () { var e = new Error('parse'); e.reason = 'parse'; throw e; });
        })
        .then(function (c) { clearTimeout(timer); return c; }, function (e) {
          clearTimeout(timer);
          if (!e.reason) { e.reason = e.name === 'AbortError' ? 'timeout' : 'network'; e.again = e.reason === 'network'; }
          throw e;
        });
    }
    return once()
      .then(null, function (e) { if (e.again) return once(); throw e; })
      .then(function (c) {
        if (!c || !Array.isArray(c.items)) { var e = new Error('parse'); e.reason = 'parse'; throw e; }
        var lines = c.items.map(function (it) {
          var props = it.properties || {};
          return {
            variant: it.variant_id, qty: it.quantity, handle: it.handle || '', title: String(it.product_title || it.title || '').slice(0, 160),
            variant_title: it.product_has_only_default_variant ? '' : String(it.variant_title || '').slice(0, 80),
            line_price: (it.final_line_price || 0) / 100, gift: it.final_line_price === 0, from_chat: props['_Added by'] === 'Chat'
          };
        });
        var snap = { status: 'ok', seq: seq, started_at: started, cart: markOf(String(c.token || '')), lines: lines, total: (c.total_price || 0) / 100, currency: c.currency || '' };
        if (seq >= haveSeq) { haveSeq = seq; haveNow = qtyByHandle(snap); }
        remarkCart(snap);
        return snap;
      })
      .then(null, function (e) { return { status: 'failed', reason: (e && e.reason) || 'network', seq: seq, started_at: started }; });
  }

  /* Before anything goes into her cart from here, her cart is read again (owner 2026-10-27: «قبل تنفيذ زر أضيفي الناقص، تأكد
     من السلة الحالية مرة ثانية»): a product that is in it by now is not added again — unless she asked for one more
     (another). A read that fails adds nothing: she is told, and tries again. */
  /* One add at a time on the page (QA recheck SA-QA-21): two buttons for the same product tapped together both read her cart
     before either added, and it went in twice. Each tap waits for the one before it, then reads her cart as that left it. */
  var adding = Promise.resolve();
  function checkedAdd(products, buttons) {
    buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-busy'); });
    adding = adding.then(function () {
      return readCartNow().then(function (now) {
        buttons.forEach(function (b) { b.disabled = false; b.classList.remove('is-busy'); });
        if (now.status !== 'ok') { buttons.forEach(function (b) { flash(b, 'ما قدرت أتأكد من سلتك، جرّبي كمان مرة'); }); return; }
        var have = qtyByHandle(now);
        var toAdd = products.filter(function (p) { return p.another || !haveIn(have, p); });
        if (!toAdd.length) { buttons.forEach(function (b) { haveAll(b); }); return; }
        return addToCart(toAdd, buttons);
      });
    }).then(null, function () {});
  }
  // everything this button would add is in her cart by now
  function haveAll(b) {
    b.disabled = true;
    if (b.classList.contains('sas-card__add')) { b.replaceWith(el('span', 'sas-card__have', 'بسلتك')); return; }
    b.textContent = 'صاروا كلهم بسلتك ✓';
  }

  function addToCart(products, buttons) {
    buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-busy'); });
    var choose = null, missed = [];
    var sections = document.getElementById('cart-icon-bubble') ? ['cart-icon-bubble'] : [];
    /* A refusal Shopify sent (422: sold out since, a limit) is not the same as an answer that never came:
       a request lost on the way back may have been added already. Sending it again added the routine twice
       (QA-06), so a lost answer is settled against the cart as it was before, never by sending again blindly. */
    var post = function (list) {
      return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: '*/*', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: list, sections: sections })
      }).then(function (r) {
        // only a 4xx (422: sold out since, a limit) is a refusal Shopify is sure of; a 5xx may have come after the
        // cart was written, so it is settled from the cart like a lost answer (QA-06 re-check: a 500 after the
        // write added the routine twice)
        var unsure = r.status >= 500;
        var fail = function (msg) { var e = new Error(unsure || r.ok ? 'lost' : msg); if (unsure || r.ok) e.lost = true; else e.refused = true; throw e; };
        return r.json().then(function (j) {
          if (!r.ok || j.status) fail(j.description || 'add');
          return j;
        }, function () { fail('add'); });
      }, function () { var e = new Error('lost'); e.lost = true; throw e; });
    };
    var names = {}, unread = 0;
    // a product page that could not be read is not a sold-out product (QA recheck SA-QA-18): she is asked to try again
    return Promise.all([
      Promise.all(products.map(function (p) { return variantFor(p.id).catch(function () { return { unread: true }; }); })),
      cartCounts()
    ])
      .then(function (got) {
        var vs = got[0], before = got[1];
        var items = [];
        vs.forEach(function (v, i) {
          if (v.id) { items.push({ id: v.id, quantity: 1, properties: { '_Added by': 'Chat', _sondos_session: conversation || '' } }); names[v.id] = products[i].title; }
          else if (v.choose) { if (!choose) choose = v.url; }
          else if (v.unread) { unread++; missed.push(products[i].title); }
          else missed.push(products[i].title);   // sold out before she tapped: said under the button, never silently left out (QA-10)
        });
        if (!items.length) throw new Error(choose ? 'choose' : unread ? 'add' : 'sold_out');
        // which of these are not in the cart yet (compared with the cart before the tap); null = cannot tell
        var notIn = function (list) {
          return cartCounts().then(function (after) {
            if (!after || !before) return null;
            return list.filter(function (it) { return (after[it.id] || 0) <= (before[it.id] || 0); });
          });
        };
        // one by one: after Shopify refused the batch for one bad line only that one stays out, and a lost
        // answer for one line is settled by the cart, never sent twice
        var unsure = false;
        var oneByOne = function (list) {
          var ok = 0;
          return list.reduce(function (q, it) {
            return q.then(function () {
              return post([it]).then(function () { ok++; }, function (e) {
                if (!e.lost) { missed.push(names[it.id]); return; }
                return notIn([it]).then(function (m) { if (m && !m.length) ok++; else { missed.push(names[it.id]); if (!m) unsure = true; } });
              });
            });
          }, Promise.resolve()).then(function () { if (!ok) throw new Error(unsure ? 'lost' : 'add'); return refreshBubble(); });
        };
        return post(items).catch(function (err) {
          if (err.lost) {
            return notIn(items).then(function (m) {
              if (!m) throw new Error('lost');                  // cannot tell: she checks the cart rather than adding twice
              if (m.length === items.length) return oneByOne(items);   // nothing landed: safe to send again
              m.forEach(function (it) { missed.push(names[it.id]); });
              return refreshBubble();
            });
          }
          if (items.length < 2) throw err;
          return oneByOne(items);
        });
      })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var inner = doc.querySelector('.shopify-section');
          if (bubble && inner) bubble.innerHTML = inner.innerHTML;
        }
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'assistant' } })); } catch (e) {}
        recheckShown();
        if (document.body.classList.contains('template-cart') && window.SondosCartSync && window.SondosCartSync.reconcile) window.SondosCartSync.reconcile('assistant');
        buttons.forEach(function (b) { done(b, choose, missed); });
      })
      .catch(function (err) {
        var why = err && err.message;
        buttons.forEach(function (b) {
          b.classList.remove('is-busy');
          if (why === 'choose' && choose) { b.disabled = false; var ln = chooseLink(choose); if (b.classList.contains('sas-card__add')) ln.className = 'sas-card__choose'; b.replaceWith(ln); return; }
          b.disabled = false;
          flash(b, why === 'sold_out' ? 'نفد هلأ' : why === 'lost' ? 'افتحي السلة وتأكدي' : 'ما زبطت، جرّبي كمان مرة');
        });
      });
  }

  /* The cart count in the header, when the add's own answer did not bring it. */
  function refreshBubble() {
    if (!document.getElementById('cart-icon-bubble')) return Promise.resolve({});
    return fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j ? { sections: j } : {}; })
      .catch(function () { return {}; });
  }

  function chooseLink(url) {
    var a = el('a', 'sas-add sas-add--link', 'اختاري الدرجة');
    a.href = url;
    return a;
  }

  function done(b, choose, missed) {
    b.classList.remove('is-busy');
    b.classList.add('is-done');
    b.textContent = '';
    b.appendChild(svg(ICON.check, 16));
    if (!b.classList.contains('sas-card__add')) b.appendChild(el('span', null, 'انضاف'));
    var host = b.closest('.sas-routine__foot') || b.closest('.sas-msg__extras');
    if (host && !host.querySelector('.sas-tocart')) {
      var a = el('a', 'sas-tocart', 'انضاف للسلة ✓ عرض السلة');
      a.href = (window.routes && window.routes.cart_url) || '/cart';
      host.appendChild(a);
    }
    // by name: she sees which step of her routine is still missing, not a vague «في منتج» (QA-10)
    if (missed && missed.length && host) host.appendChild(el('p', 'sas-routine__pick', (missed.length === 1 ? 'ما انضاف: ' : 'ما انضافوا: ') + missed.join('، ') + ' — نفد أو ما توفّر هلأ. الباقي انضاف للسلة.'));
    if (choose && host) {
      var c = el('p', 'sas-routine__pick');
      c.appendChild(document.createTextNode('منتج إله درجات ما انضاف — '));
      var l = el('a', null, 'اختاري درجتك');
      l.href = choose;
      c.appendChild(l);
      host.appendChild(c);
    }
  }


  function flash(b, text) {
    if (b.classList.contains('sas-card__add')) { b.classList.add('is-error'); b.setAttribute('title', text); setTimeout(function () { b.classList.remove('is-error'); }, 2400); return; }
    var label = b.querySelector('.sas-add__label') || b;
    var old = label.textContent;
    label.textContent = text;
    setTimeout(function () { label.textContent = old; }, 2400);
  }

  /* ───────────────────────── network ───────────────────────── */
  function post(path, body) {
    if (cfg.demo) return Promise.resolve(null);
    return fetch(cfg.endpoint + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).catch(function () { return null; });
  }

  // a line under a reply about her cart: written about her cart as it was then, or not checked against it now
  function cartNote(b, words) {
    var n = b.node.querySelector('.sas-msg__cart');
    if (!n) { n = el('div', 'sas-msg__cart'); b.node.insertBefore(n, b.extras); }
    n.textContent = words;
  }
  /* The saved replies (resume, or the answer another request wrote): one read of her cart now. A reply about another cart
     says so; the newest one, if it is the answer she is waiting for (`waited`), is held back like a live one. */
  // the replies about her cart, marked against her cart now: about another cart, or not checked (no read)
  function markSaved(pairs, now) {
    var printNow = now && now.status === 'ok' ? cartPrint(now) : null;
    pairs.forEach(function (p) {
      if (p.m.cartFp == null || p.replaced) return;
      p.b.node.setAttribute('data-cart-fp', p.m.cartFp);
      if (printNow == null) cartNote(p.b, 'هالجواب كان عن سلتك وقتها.');
      else if (printNow !== p.m.cartFp) cartNote(p.b, CART_THEN);
    });
  }
  function showSaved(list, waited, clear, already) {
    var about = list.some(function (m) { return m.role === 'assistant' && m.cartFp != null; });
    var check = about ? readCartNow() : Promise.resolve(null);
    /* Her saved chat, not an answer she waits for (owner 2026-10-28: «بتطلع الشاشة بيضا وبعدها بتطلع المحادثة»): on the screen
       at once, the replies about her cart marked when the read comes — nothing waits for it. `already`: the same chat is on
       the screen from her device, so only the marks are added. */
    if (!waited) {
      if (clear && !already) clear();
      var shown = already || showMessages(list);
      return check.then(function (now) { markSaved(shown, now); return shown; });
    }
    return check.then(function (now) {
      var printNow = now && now.status === 'ok' ? cartPrint(now) : null;
      var lastAt = -1, again = null;
      list.forEach(function (m, i) { if (m.role === 'assistant') lastAt = i; });
      if (clear) clear();
      var pairs = showMessages(list, function (m, i) {
        if (!waited || i !== lastAt || m.cartFp == null || (printNow != null && printNow === m.cartFp)) return null;
        if (m.turn) unseenTurns.push(m.turn);
        again = list[i - 1] && list[i - 1].role === 'user' ? list[i - 1].text : null;
        return printNow == null ? CART_UNCHECKED : CART_CHANGED;
      });
      if (again) setChips([{ label: printNow == null ? 'جرّبي كمان مرة' : 'جاوبيني حسب سلتي هلأ', run: function () { setChips([]); sendMessage(again, { silent: true }); } }]);
      pairs.forEach(function (p) {
        if (p.m.cartFp == null || p.replaced) return;
        p.b.node.setAttribute('data-cart-fp', p.m.cartFp);
        if (printNow == null) cartNote(p.b, 'هالجواب كان عن سلتك وقتها.');
        else if (printNow !== p.m.cartFp) cartNote(p.b, CART_THEN);
      });
      return pairs;
    });
  }

  /* Her saved chat, the end first (owner 2026-10-28: «بحسها بتعلق لحظات»): laying out every message and card at once held a mid
     phone's main thread ~0.5 s as the chat opened, her finger unanswered. The last few are drawn now; the older ones go in above
     them two at a time in idle moments — never while her finger is on the chat — and what she sees does not move (the height
     they add is given back to scrollTop, unless the browser's own scroll anchoring already did). */
  var SHOW_FIRST = 4;
  function showLater(nodes) {
    var hidden = nodes.slice(0, Math.max(0, nodes.length - SHOW_FIRST));
    if (!hidden.length) return;
    hidden.forEach(function (n) { n.style.display = 'none'; n.style.animation = 'none'; });
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 32); };
    (function step() {
      if (!hidden.length || !ui.log) return;
      if (state.touching) { setTimeout(step, 150); return; }
      idle(function () {
        var log = ui.log;
        if (!log) return;
        var oldTop = log.scrollTop, oldH = log.scrollHeight;
        hidden.splice(-2).forEach(function (n) { n.style.display = ''; });
        var grew = log.scrollHeight - oldH;
        if (grew > 0 && Math.abs(log.scrollTop - oldTop) < 2) log.scrollTop = oldTop + grew;
        step();
      });
    })();
  }
  function showMessages(list, replace) {
    var from = ui.log ? ui.log.children.length : 0;
    var pairs = showMessagesNow(list, replace);
    if (ui.log && !replace) showLater([].slice.call(ui.log.children, from));
    return pairs;
  }
  function showMessagesNow(list, replace) {
    var pairs = [];
    list.forEach(function (m, i) {
      if (m.role === 'user') { addUser(m.text); return; }
      var instead = replace ? replace(m, i) : null;
      if (instead) { pairs.push({ m: m, b: addBot(instead), replaced: true }); return; }
      var b = addBot(m.text || '');
      pairs.push({ m: m, b: b });
      // a routine comes back as she saw it — morning, night, weekly, the total and «add all» (QA-11)
      if (m.cards && m.cards.length) renderCards(b, { layout: m.layout || 'list', items: m.cards, am: m.am || [], pm: m.pm || [], weekly: m.weekly || [], later: m.later || [], apart: m.apart || [], apart_title: m.apart_title });   // each card carries its pace
      if (m.policy && m.policy.lines) renderPolicy(b, m.policy);
      if (m.handoff) renderHandoff(b, {});
    });
    return pairs;
  }

  /* Her message is answered by a request this page is not reading — the page reloaded mid-answer, or a second
     press reached the Worker while the first was still running («دهنية» twice, both paid, R3 2026-10-24). The
     Worker runs one message of a conversation at a time; the page waits until it is saved and shows the
     conversation as saved, instead of sending again. */
  function whenSaved(b, resumed) {
    var tries = 0, g = state.gen;
    setBusy(true);
    status(b, 'لحظة…');
    (function poll() {
      if (g !== state.gen) return;
      sessionRead(conversation)
        .then(function (j) {
          if (g !== state.gen) return;   // she started a new chat meanwhile
          if ((!j || j.pending) && ++tries < 60) { setTimeout(poll, 3000); return; }
          if (j && j.messages && j.messages.length) {
            state.remaining = j.remaining;
            keepTranscript(conversation, j.messages);
            // drawn again once her cart is read: the answer she waited for is checked like a live one
            return showSaved(j.messages, true, function () { ui.log.textContent = ''; }).then(function () {
              ui.log.scrollTop = ui.log.scrollHeight;
              setBusy(false);
              // her chat opened while its last answer was still being written: once it is saved, the product page's questions as on
              // any return — from this final read, for this product and chat only (Codex PDP-QA18-001); never under a live answer
              // still not saved when the waiting ran out: nothing of an answer not yet written is offered — the benefits question only
              // (Codex PDP-QA19-001)
              if (resumed && g === state.gen) { state.pdp = j.pending === false ? pdpFor(j.pdp_actions, conversation) : null; productChips(); }
            });
          }
          status(b, null);
          b.raw = 'صار خلل صغير عندي 🙏 جرّبي كمان مرة.';
          setText(b.text, b.raw);
          setBusy(false);
        });
    })();
  }

  /* Her chat as last saved, kept on her device (owner 2026-10-28: «لما افتح المساعدة وبكون في محادثة قديمة بتطلع الشاشة بيضا
     وبعدها بتطلع المحادثة» — measured: up to 2.8 s blank, the server loading its catalog for /session, then a cart read). It is
     shown at once; the server's copy follows and wins. Never trusted for anything else; gone with a new chat or «امسحي ذاكرة». */
  var K_TX = 'sas_tx';
  function keepTranscript(conv, messages) {
    try { if (!conv || !messages || !messages.length) localStorage.removeItem(K_TX); else localStorage.setItem(K_TX, JSON.stringify({ c: conv, at: Date.now(), m: messages })); } catch (e) {}
  }
  function keptTranscript(conv) {
    try {
      var t = JSON.parse(localStorage.getItem(K_TX) || 'null');
      return t && t.c === conv && Date.now() - t.at < 30 * 864e5 && t.m && t.m.length ? t.m : null;
    } catch (e) { return null; }
  }
  // after a reply: the saved chat as the server keeps it, for the next return
  function refreshKept() {
    if (cfg.demo || !conversation) return;
    var c = conversation;
    fetch(cfg.endpoint + '/session?device=' + device + '&conversation=' + encodeURIComponent(c))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.conversation === c && c === conversation && j.messages && !j.pending) keepTranscript(c, j.messages); })
      .catch(function () {});
  }

  /* /session, answered within 10 s or not at all (QA recheck SA-QA-07: with no answer the chat opened blank and stayed so).
     null = the server said no; undefined = no answer came (the network, or the 10 s) — her chat is not dropped for that. */
  function sessionRead(c) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 10000) : 0;
    // on a product page it also asks which of its two questions this chat can offer (PDP plan §4.5)
    var asks = cfg.pageType === 'product' && cfg.product ? '&product=' + encodeURIComponent(cfg.product) : '';
    return fetch(cfg.endpoint + '/session?device=' + device + '&conversation=' + encodeURIComponent(c) + asks, { signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { clearTimeout(timer); return j; }, function () { clearTimeout(timer); return undefined; });
  }

  function resume() {
    if (cfg.demo || !conversation) { welcome(); return Promise.resolve(); }
    var g = state.gen, c = conversation;
    var kept = keptTranscript(conversation);
    var keptPairs = kept ? showMessages(kept) : null;
    if (kept) ui.log.scrollTop = ui.log.scrollHeight;
    return sessionRead(c)
      .then(function (j) {
        if (g !== state.gen || c !== conversation) return;   // she started a new chat before it came: it is not hers to show (SA-QA-05)
        if (j === undefined) { if (!kept) welcome(); else productChips(); return; }   // no answer: the chat kept on her device stays, or the welcome
        if (!j || !j.conversation || !j.messages || (!j.messages.length && !j.pending)) {
          conversation = null; store(K_CONV, null); keepTranscript(null);
          if (kept) ui.log.textContent = '';
          welcome(); return;
        }
        state.remaining = j.remaining;
        state.pdp = pdpFor(j.pdp_actions, c);
        keepTranscript(conversation, j.messages);
        // the same chat as the one on the screen: only its marks; anything newer (an answer, a price): shown as the server has it
        var same = kept && !j.pending && JSON.stringify(kept) === JSON.stringify(j.messages);
        return showSaved(j.messages, false, kept ? function () { ui.log.textContent = ''; } : null, same ? keptPairs : null).then(function () { afterResume(j); });
      })
      .catch(function () { if (!kept) welcome(); });
  }
  // after the saved replies are on the page: where she was, or «نكمّل / محادثة جديدة»
  /* Her chat just opened at its end: what grows under it for a moment (the marks about her cart, a late image or font) keeps it
     there, until she scrolls herself or `ms` pass. */
  function settleToEnd(ms) {
    var until = Date.now() + ms;
    (function tick() {
      var log = ui.log;
      if (!log || state.manual || Date.now() > until) return;
      if (log.scrollHeight - log.clientHeight - log.scrollTop > 2) log.scrollTop = log.scrollHeight;
      requestAnimationFrame(tick);
    })();
  }
  /* Back to where she was: her chat is still being drawn (cards, the marks about her cart, its older messages going in above —
     showLater), so the place is set again while it grows — until she moves it herself or `ms` pass. The place is her distance
     from the chat's end: what goes in above does not change it, a distance from the top did (Codex PDP-QA21-002: a long chat came
     back at 825 instead of 475, the older messages pushed in above and taken for her own scroll). Only her hand stops it. */
  function settleAt(d, ms) {
    var log = ui.log, until = Date.now() + ms, moved = false, ev = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    if (!log) return;
    function her() { moved = true; }
    ev.forEach(function (n) { log.addEventListener(n, her, { passive: true }); });
    (function tick() {
      if (moved || ui.log !== log || Date.now() > until) { ev.forEach(function (n) { log.removeEventListener(n, her); }); return; }
      var want = Math.max(0, log.scrollHeight - log.clientHeight - d);
      if (Math.abs(log.scrollTop - want) > 2) log.scrollTop = want;
      requestAnimationFrame(tick);
    })();
  }
  function afterResume(j) {
    // back while her last message is still being answered: wait for that answer instead of losing it
    if (j.pending) { whenSaved(addBot(''), true); return; }
    /* Back from a product she opened here: just where she was. Only on Back — the place is kept on every leaving of the chat
       (pagehide), and read on any later opening it put her mid-chat instead of at its end (owner 2026-10-28: «مش دايما بنزلنا اخر
       المحادثة»); read once, then gone. */
    var y = null, back = false;
    try { y = sessionStorage.getItem('sas_y'); sessionStorage.removeItem('sas_y'); } catch (e) {}
    try { back = (performance.getEntriesByType('navigation')[0] || {}).type === 'back_forward'; } catch (e) {}
    if (y != null && back) {
      state.manual = true;
      // the end asked for while her chat was drawn again (each of her messages asks it) is not hers to follow now
      state.anchor = null; scrollMode = undefined;
      if (Number(y)) settleAt(Number(y), 2500); else ui.log.scrollTop = ui.log.scrollHeight;
      updateJump();
      // her chat's questions on this product page too, at its end — state.manual keeps her place (Codex PDP-QA20-001)
      productChips();
      return;
    }
    /* Her chat goes on where she left it, from wherever she opens it (owner 2026-10-28: «تكمل عادي مش تعيد من الاول»; «من وين ما
       افتح المساعدة… تظهر»): no question first — «محادثة جديدة» is in the menu. From her cart, when it changed since the last reply
       about it, one line offers to look again (the replies about the old cart are marked by showSaved). */
    state.anchor = null;
    ui.log.scrollTop = ui.log.scrollHeight;
    settleToEnd(3000);
    if (!cartReview) { productChips(); return; }
    var changed = [].some.call(ui.log.querySelectorAll('[data-cart-fp] .sas-msg__cart'), function (n) { return n.textContent === CART_THEN; });
    if (changed) {
      var moved = addBot('سلتك تغيّرت من آخر مرة 🛒 بدك أراجعها معك من جديد؟');
      moved.node.classList.add('sas-msg--note');
      setChips([{ label: 'راجعي سلتي من جديد', run: function () { setChips([]); sendMessage('راجعي سلتي من جديد بعد ما غيّرتها'); } }]);
      ui.log.scrollTop = ui.log.scrollHeight;
    }
  }

  /* Her chat goes on from a product page (PDP plan §2.5, §4.5): its questions in the place the quick actions already use, with no
     greeting again — the benefits one always; «بناسبني؟» and «بيمشي مع روتيني؟» only when the Worker said this chat heard it from
     her, for this very product and chat (pdpFor). A late, failed or other chat's answer shows the benefits one alone. */
  var Q_BENEFITS = 'شو فوائد هاد المنتج ولمين بناسب؟', Q_PERSONAL = 'هاد المنتج بناسبني؟', Q_ROUTINE = 'هاد المنتج بيمشي مع روتيني؟';
  function pdpFor(a, c) {
    if (!a || typeof a !== 'object' || cfg.pageType !== 'product' || !cfg.product || a.product !== cfg.product || !c || a.conversation !== c) return null;
    return { product: a.product, conversation: a.conversation, personal: a.personal === true, routine: a.routine === true };
  }
  function productChips() {
    if (cfg.fresh || cfg.pageType !== 'product' || !cfg.product || state.busy) return;
    var p = pdpFor(state.pdp, conversation);
    var list = [{ label: Q_BENEFITS, send: Q_BENEFITS }];
    if (p && p.personal) list.push({ label: Q_PERSONAL, send: Q_PERSONAL });
    if (p && p.routine) list.push({ label: Q_ROUTINE, send: Q_ROUTINE });
    setChips(list);
  }

  function submit(e) {
    if (e) e.preventDefault();
    var text = ui.input.value.trim();
    if (!text || state.busy) return;
    ui.input.value = '';
    try { sessionStorage.removeItem(K_DRAFT); } catch (x) {}
    fitInput();
    ui.send.disabled = true;
    // phone: the keyboard goes down so the answer (and its cards) have the whole screen; one tap on the box
    // brings it back. A real keyboard keeps its focus for the next question.
    if (touchKeys) ui.input.blur();
    sendMessage(text);
  }

  function setBusy(on) {
    state.busy = on;
    ui.sheet.classList.toggle('is-busy', on);
    ui.send.disabled = on || !ui.input.value.trim();
    ui.chips.querySelectorAll('button').forEach(function (b) { b.disabled = on; });
  }

  function sendMessage(text, opts) {
    opts = opts || {};
    if (state.busy) return;
    foldOpening();
    if (!opts.silent) addUser(text);
    setChips([]);
    ui.input.placeholder = PLACEHOLDER;
    // «الجواب فادك؟» only ever under the newest answer: unanswered ones step aside
    ui.log.querySelectorAll('.sas-rate:not(.is-done)').forEach(function (r) { r.remove(); });
    var b = botMessage();
    status(b, 'لحظة…');
    setBusy(true);
    if (cfg.demo) return demo(text, b);

    var turn = 0, gotText = false;
    /* The text is revealed at a steady pace instead of a sentence at a time, and what goes under it (the
       cards, a policy, the WhatsApp button) waits until it is written. The model picks the products before
       it speaks, so the routine used to land first and the text then pushed it down — «بتنط» (owner, 2026-10-23). */
    var later = [], shown = 0, ticking = false, ended = false, typed = null;
    var instant = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* The reply reaches the page whole, after the Worker has checked it, so the reveal is only a short typing feel: a fifth of
       what is left each frame writes 457 characters in about 0.35 s, where a twenty-fourth took 1.2 s more after the words
       had already arrived (measured 2026-10-27, «ليش بطيئة»). */
    function tick() {
      var raw = b.raw || '';
      var left = raw.length - shown;
      if (left > 0) {
        shown = instant ? raw.length : shown + Math.max(3, Math.ceil(left / 5));
        setText(b.text, raw.slice(0, shown));
        scrollToEnd();
      }
      if (shown < (b.raw || '').length) { requestAnimationFrame(tick); return; }
      ticking = false;
      if (ended && typed) { var done = typed; typed = null; done(); }
    }
    function reveal() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
    function whenTyped() {
      return new Promise(function (resolve) {
        ended = true;
        if (!ticking && shown >= (b.raw || '').length) resolve(); else typed = resolve;
      });
    }
    // one id for this press of «send»: if it reaches the Worker twice, it is answered once — and «جرّبي كمان مرة» after a reply
    // that stopped half-way sends the same one, so an answer the Worker did save is shown, never paid for again
    var mid = opts.mid || (Math.random().toString(36).slice(2, 10) + Date.now().toString(36)).slice(0, 20);
    /* A reply that stops coming is given up on, never waited for forever (QA recheck SA-QA-07: on a phone network that went
       quiet she watched «لحظة…» with the send button locked). 20 s to answer at all, then 60 s of silence between two events —
       the longest model round of 36 measured R3 turns was 16 s (2026-10-29), and every round starts with a status line. */
    var gen = state.gen;
    var ctl = window.AbortController ? new AbortController() : null;
    var quiet = 0;
    var terminal = false;   // done / refusal / error / settled: the Worker said how this message ended
    function wait(ms) { if (!ctl) return; clearTimeout(quiet); quiet = setTimeout(function () { ctl.abort(); }, ms); }
    state.abort = function () { clearTimeout(quiet); if (ctl) ctl.abort(); };
    var follow = false;   // answered by another request: show the saved conversation when it is ready
    var sent = null;      // her cart as this message's own read found it
    /* her reply was written about a read cart: checked against her cart once it is written. It is shown as it comes (owner 2026-10-28:
       «تنكتب كلمة كلمة» — held, she watched dots for the whole reply); a cart that really changed meanwhile takes it back. */
    var hold = false;
    var retry = null;     // the shop asked her to try again (her cart could not be read, or changed): the same words, resent
    status(b, 'لحظة…');
    readCartNow()
      .then(function (snap) {
        sent = snap;
        hold = snap.status === 'ok';
        var unseen = unseenTurns.splice(0, unseenTurns.length);
        var body = JSON.stringify({ device: device, conversation: conversation, message: text, mid: mid, unseen: unseen.length ? unseen : undefined, page: { type: cfg.pageType, product: cfg.product || null, cart: snap, collection: cfg.collection || undefined, title: cfg.collectionTitle || undefined }, intake: opts.intake || undefined, entry: cfg.src || undefined, test: cfg.test || undefined });
        if (gen !== state.gen) throw new Error('left');   // she started a new chat while her cart was read
        wait(20000);
        return fetch(cfg.endpoint + '/chat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, signal: ctl ? ctl.signal : undefined });
      })
      .then(function (res) {
        if (!res.ok || !res.body) throw new Error('http ' + res.status);
        wait(60000);
        var reader = res.body.getReader();
        var dec = new TextDecoder();
        var buf = '';
        function pump() {
          return reader.read().then(function (r) {
            /* The stream closed without saying how the message ended (QA recheck SA-QA-06: the Worker stopped mid-answer and an
               empty bubble stayed, as if that was the answer): handled like a lost connection below. */
            if (r.done) { clearTimeout(quiet); if (!terminal) throw new Error('cut'); return; }
            wait(60000);
            buf += dec.decode(r.value, { stream: true });
            var i;
            while ((i = buf.indexOf('\n\n')) >= 0) {
              var block = buf.slice(0, i);
              buf = buf.slice(i + 2);
              var ev = /^event: (.+)$/m.exec(block), data = /^data: (.+)$/m.exec(block);
              if (!ev || !data) continue;
              var d;
              try { d = JSON.parse(data[1]); } catch (x) { continue; }
              handle(ev[1], d);
            }
            return pump();
          });
        }
        return pump();
      })
      .catch(function () {
        clearTimeout(quiet);
        if (gen !== state.gen || terminal) return;   // a chat she left, or a message that had already ended
        status(b, null);
        hold = false;
        /* Half a reply is not shown as the reply (SA-QA-06): what came of it goes, the shop's line takes its place, and «جرّبي كمان
           مرة» sends the same press again — the Worker answers it from what it saved, or runs it if it never did. */
        gotText = true;
        b.raw = 'صار خلل صغير عندي 🙏 جرّبي كمان مرة، أو احكي مع خبيرة سندس على واتساب.';
        shown = 0; setText(b.text, '');
        later = [function () { renderHandoff(b, {}); }];
        retry = { label: 'جرّبي كمان مرة', text: text, mid: mid };
        reveal();
      })
      .then(function () {
        if (gen !== state.gen) return;
        if (!hold || follow || (!b.raw && !later.length)) return;   // nothing came to hold (an error, the shop's line)
        if (!gotText) status(b, 'لحظة…');   // nothing on her screen yet; a reply she is reading gets no line over it
        return readCartNow().then(function (now) {
          status(b, null);
          if (sameCart(sent, now)) { b.node.setAttribute('data-cart-fp', cartPrint(sent)); reveal(); return; }
          /* Her cart changed while this was written, or the check could not read it (owner 2026-10-27: «ممنوع عرض جواب
             الـAI أو كروته، حتى مع تنبيه»): none of it is shown — not the words, not its cards — a clear line and a fresh try. */
          var changed = now.status === 'ok';
          b.raw = changed ? CART_CHANGED : CART_UNCHECKED;
          shown = 0; setText(b.text, '');   // the words already on her screen go: the line takes their place, nothing of them stays
          later = [];
          if (turn) unseenTurns.push(turn);
          retry = { label: changed ? 'جاوبيني حسب سلتي هلأ' : 'جرّبي كمان مرة', text: text };
          reveal();
        });
      })
      .then(whenTyped)
      .then(function () {
        if (gen !== state.gen) return;   // she is on a new chat now: nothing of this one is drawn into it
        state.abort = null;
        if (follow) { whenSaved(b); return; }
        later.forEach(function (f) { f(); });
        status(b, null);
        setBusy(false);
        setTimeout(refreshKept, 600);   // her device's copy of the chat, for the next return
        if (b.text.textContent || b.extras.childNodes.length) rate(b, turn);
        if (state.remaining <= 0) limitReached();
        else if (retry) setChips([{ label: retry.label, run: function () { setChips([]); sendMessage(retry.text, { silent: true, mid: retry.mid }); } }]);
        else if (!opts.keepChips) setChips(followUps());
        if (window.matchMedia('(min-width: 750px)').matches) ui.input.focus();
      });

    function handle(type, d) {
      if (gen !== state.gen) return;   // an event of a chat she left («محادثة جديدة» mid-answer) changes nothing (SA-QA-05)
      if (type === 'done' || type === 'refusal' || type === 'error' || type === 'settled') { terminal = true; clearTimeout(quiet); }
      if (type === 'meta') {
        if (d.conversation && d.conversation !== conversation) { conversation = d.conversation; store(K_CONV, conversation); }
        return;
      }
      if (type === 'status') { status(b, d.text); return; }
      if (type === 'delta') {
        b.raw = (b.raw || '') + d.text;
        if (!gotText) { gotText = true; status(b, null); }
        reveal();
        return;
      }
      if (type === 'cards') { later.push(function () { renderCards(b, d); }); return; }
      if (type === 'policy') { later.push(function () { renderPolicy(b, d); }); return; }
      if (type === 'handoff') { later.push(function () { renderHandoff(b, d); }); return; }
      if (type === 'settled') { follow = true; return; }
      if (type === 'refusal') {
        hold = false;
        if (d.reason === 'cart_unread' || d.reason === 'cart_stale') retry = { label: 'جرّبي كمان مرة', text: text };
      }
      if (type === 'refusal') { status(b, null); gotText = true; b.raw = d.text; reveal(); if (d.reason === 'conversation') state.remaining = 0; if (d.reason === 'busy') follow = true; return; }
      if (type === 'error') { hold = false; status(b, null); if (!gotText) { gotText = true; b.raw = d.text; reveal(); } later.push(function () { renderHandoff(b, {}); }); return; }
      if (type === 'done') { turn = d.turn; state.remaining = d.remaining; state.pdp = pdpFor(d.pdp_actions, conversation); }
    }
  }

  /* No suggestion row under the answers: the owner, 2026-10-23 — «مش ضروريات، عاملت عجقة». She writes
     what she wants; the opening ways in stay. */
  function followUps() {
    return [];
  }

  function limitReached() {
    setChips([{ label: 'محادثة جديدة', run: newConversation }]);
  }

  function newConversation() {
    // an answer still coming for the chat she leaves is stopped and dropped, not drawn into the new one (SA-QA-05)
    state.gen++;
    if (state.abort) { state.abort(); state.abort = null; }
    if (state.busy) setBusy(false);
    conversation = null;
    keepTranscript(null);
    state.pdp = null;
    state.anchor = null;
    try { sessionStorage.removeItem('sas_y'); } catch (e) {}
    store(K_CONV, null);
    state.remaining = 15;
    ui.log.textContent = '';
    ui.input.placeholder = PLACEHOLDER_START;
    welcome();
  }

  /* «مسحت» only once the server has said so: a new device id hides the old chats from this phone but
     deletes nothing, and the sheet said they were gone when the request had failed (QA-12). */
  function forget() {
    if (state.busy) return;
    setBusy(true);
    (cfg.demo ? Promise.resolve(true) : fetch(cfg.endpoint + '/forget', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device: device }) })
      .then(function (r) { return r.ok; }, function () { return false; }))
      .then(function (ok) {
        setBusy(false);
        if (!ok) {
          var f = addBot('ما قدرت أمسح الذاكرة هلأ 🙏 جرّبي كمان شوي من «⋯ ← امسحي ذاكرة المحادثات».');
          f.node.classList.add('sas-msg--note');
          return;
        }
        device = randomId();
        store(K_DEVICE, device);
        newConversation();
        var n = addBot('مسحت ذاكرة محادثاتك من عنا 🌸 منبلّش من جديد.');
        n.node.classList.add('sas-msg--note');
      });
  }

  function showAbout() {
    var a = ui.about;
    a.textContent = '';
    var box = el('div', 'sas-about__box');
    box.appendChild(el('h3', 'sas-about__title', 'عن مساعدة سندس'));
    [
      'مساعدة سندس هي ذكاء اصطناعي، مش شخص. بتختارلك من منتجات متجرنا بس، حسب اللي بتحكيه عن بشرتك.',
      'ممكن تغلط أو يكون جوابها ناقص. اللي بتحكيه نصايح عامة للعناية بالبشرة، مش استشارة طبية.',
      // no doctor anywhere (owner, 2026-10-23: «ما بدي الطبيب ابدا، حوّل واتساب وخلص»)
      'قبل أي منتج جديد راجعي العبوة وصفحة المنتج، وإذا عندك حالة خاصة أو حامل أو مرضعة احكي مع خبيرة سندس على واتساب.',
      'ما بتقدر تعمل خصومات أو عروض، ولا تعدّل طلب، ولا توعد بإشي باسم المتجر — هاد عند خبيرة سندس على واتساب.',
      'محادثاتك وتفضيلات بشرتك بتنحفظ 30 يوم عشان تكمّلي من وين ما وقفتي. ما تشاركي أرقام أو معلومات شخصية. بتقدري تمسحيها من «⋯ ← امسحي ذاكرة المحادثات».'
    ].forEach(function (t) { box.appendChild(el('p', 'sas-about__p', t)); });
    var ok = el('button', 'sas-primary', 'تمام');
    ok.type = 'button';
    ok.addEventListener('click', closeAbout);
    box.appendChild(ok);
    a.appendChild(box);
    a.hidden = false;
    ok.focus();
  }
  // back to ⋯, the button it was opened from (the keyboard stays down on a phone)
  function closeAbout() {
    ui.about.hidden = true;
    ui.moreBtn.focus({ preventScroll: true });
  }

  /* ───────────────────────── design preview (no Worker yet) ─────────────────────────
     Until the Worker is connected (Theme Editor → «مساعدة سندس» → endpoint),
     the sheet still opens so the design can be reviewed on R3. Every reply says
     plainly that it is a preview; the products are real and live-priced. */
  var DEMO_ROUTINE = ['cosrx-salicylic-acid-daily-gentle-cleanser-150mlغسول', 'تونر-أنوا-المنقي-للبشرة-بـحمض-الأزيليك-والسيكا-250-مل', 'سيروم-مهدئ-بحمض-الأزيليك-10-هيالورون-من-انوا', '345-dr-althea-345-relief-cream', 'واقي-الشمس-اكسس-واي'];
  var DEMO_LIST = ['cosrx-advanced-snail-92-all-in-one-cream-100g-for-oily-skin', 'cosrx-oil-free-ultra-moisturizing-lotion-كريم-الترطيب-الخالي-من-الزيوت', 'كريم-الكولاجين-بفيتامين-سي-من-ميديكيوب'];
  function demoProduct(handle, why) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return null;
      return { id: handle, title: p.title, brand: /sondos/i.test(p.vendor || '') ? '' : p.vendor, price: p.price / 100, compare: p.compare_at_price > p.price ? p.compare_at_price / 100 : 0, image: p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) + (p.featured_image.indexOf('?') > 0 ? '&' : '?') + 'width=240' : '', url: '/products/' + handle, available: p.available, step: '', why: why, caveats: [] };
    }).catch(function () { return null; });
  }
  function demo(text, b) {
    var routine = /روتين/.test(text);
    var whys = routine ? ['ساليسيليك لطيف بيفتح المسام بالغسيل', 'أزيليك وسنتيلا بيهدّوا الحبوب', 'أزيليك ١٠٪ بالليل للحبوب والآثار', 'نياسيناميد وسيراميد بدون ما يثقّل', 'خفيف وما بيسدّ المسام'] : ['حلزون بيرطّب ويهدّي بدون لمعة', 'ترطيب خالي من الزيوت للبشرة اللي بتلمع', 'فيتامين C للنضارة وتوحيد اللون'];
    setTimeout(function () { status(b, 'بدوّر بالمتجر على الأنسب إلك…'); }, 500);
    Promise.all((routine ? DEMO_ROUTINE : DEMO_LIST).map(function (h, i) { return demoProduct(h, whys[i]); })).then(function (ps) {
      ps = ps.filter(Boolean);
      setTimeout(function () {
        status(b, null);
        if (routine) {
          var p = ps.map(function (x, i) { x.step = ['cleanser', 'toner', 'serum', 'moisturizer', 'sunscreen'][i]; return x; });
          renderCards(b, { layout: 'routine', items: p, am: [p[0], p[1], p[3], p[4]].filter(Boolean).map(function (x) { return x.id; }), pm: [p[0], p[1], p[2], p[3]].filter(Boolean).map(function (x) { return x.id; }) });
        } else {
          renderCards(b, { layout: 'list', items: ps });
        }
        var t = routine
          ? 'هاد مثال على شكل الروتين من منتجات المتجر 🌸 لما نربط المساعدة، بتبنيه على مقاس بشرتك.'
          : 'هاي أمثلة من منتجات المتجر على شكل الاقتراحات 🌸 لما نربط المساعدة، رح تختارلك حسب بشرتك واللي بيضايقك بالضبط.';
        var i = 0;
        var tick = setInterval(function () {
          b.text.textContent = t.slice(0, i += 6);
          scrollToEnd();
          if (i >= t.length) {
            clearInterval(tick);
            var n = el('p', 'sas-demo', 'معاينة للتصميم — الأجوبة الحقيقية بتشتغل لما نربط المساعدة.');
            b.node.appendChild(n);
            setBusy(false);
            // a new chat started while this was typing: leave its chips alone
            if (b.node.isConnected) setChips(followUps());
          }
        }, 30);
      }, 900);
    });
  }

  if (cfg.page) {
    addEventListener('pagehide', function () {
      // her place as its distance from the chat's end (settleAt)
      try { if (ui.log && conversation) sessionStorage.setItem('sas_y', String(Math.max(0, Math.round(ui.log.scrollHeight - ui.log.clientHeight - ui.log.scrollTop)))); } catch (e) {}
    });
  }

  window.SondosAssistant = { ready: true, open: open, close: close };
  if (cfg.page) open({ prompt: (query.q || '').slice(0, 600) || null });
})();
